import { jsx as e, jsxs as p, Fragment as Q } from "react/jsx-runtime";
import { withManagedProps as y } from "@made-people/managed-props";
import { z as t } from "zod";
import { withZod as P } from "@made-people/react-prop-guard";
import W, { useEffect as $, useState as V, isValidElement as Xt, useRef as Ee, useCallback as Ge, useMemo as Qt } from "react";
import { p as Zt, a as qt, b as q, c as Jt, s as ea, d as ta, e as aa, f as na, g as oa, h as sa, i as ia, j as ra, k as la, l as ca, m as da, n as ua, o as pa, q as ma, r as ha, t as ba, u as ga, v as Ce, w as fa, x as va, y as ya, z as Pa, A as Sa, B as wa, C as _a, D as ka, E as Na, F as Ta, G as Ca, H as Aa, I as Ba, J as ge } from "./blueprint-8b5655be.mjs";
import { Drawer as j } from "@made-people/blueprint-drawer";
import * as le from "@radix-ui/react-dialog";
import { useOverlayState as Da, overlayEventEmitter as ce } from "@made-people/blueprint-overlay";
import { useProductBase as O, ProductLink as ye, useProductAttributeGetter as ee, useProductPriceInfo as Pe, useProductDataModel as Z, useBundlePurchaseInfo as Ae, useProductImages as Ia, useMediaAttributeGetter as Oe, useRelatedProducts as Be, ProductProvider as je, filterMediaOnAttributeValues as et, useProductSpecificationGroup as La, useProductAttribute as K, useProductPurchaseStatus as De, useProductOptions as Me, useProductSiblings as tt, useBundleOptions as He, useBundleItemId as za, useBundlePurchaseStatus as xa, useProductHasOptionsInStock as Ra } from "@made-people/grease-product";
import { useTranslate as L } from "@made-people/grease-translations";
import Ea from "clsx";
import { accordionItemSchema as Ga, accordionSchema as Wa, Accordion as Oa } from "@made-people/blueprint-accordion";
import { useKeenSlider as Ze } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import { ResponsiveImage as te, responsiveImageSchema as at } from "@made-people/blueprint-responsive-image";
import { useBreakpointVisibility as ja } from "@made-people/blueprint-ui-hooks";
import { responsiveVideoSchema as Ma, ResponsiveVideo as nt } from "@made-people/blueprint-responsive-video";
import { MIX_AND_MATCH_IMAGE_ATTRIBUTE_KEY as ot } from "@made-people/blueprint-mix-and-match";
import { badgeSchema as st, Badge as Ke } from "@made-people/blueprint-badge";
import { CartEventAdditionalDataProvider as Ha, useUpdateCart as Ie, useCartMethod as Ka } from "@made-people/grease-cart";
import { uiEventEmitter as Va } from "@made-people/grease-ui-events";
import { Heading as Ua } from "@made-people/blueprint-heading";
import { isNotUndefined as $a } from "@made-people/typeguards-common";
import { motion as J, AnimatePresence as de, cubicBezier as it } from "motion/react";
import { linkAsLinkSchema as Fa, Link as Ya, LinkAsLink as Xa, linkAsButtonSchema as Qa, LinkAsButton as Za } from "@made-people/blueprint-link";
import { buttonContentPropsSchema as ue, ButtonAsButton as fe, Button as oe, buttonAsButtonSchema as We, ButtonAsSpan as rt, buttonAsSpanSchema as qa } from "@made-people/blueprint-button";
import { toast as Ja } from "sonner";
import { productCardSchema as en, ProductCard as tn } from "@made-people/blueprint-product-card";
import { SearchResultProvider as lt, useSearchResultItems as an } from "@made-people/grease-search";
import { swipeableProductListSchema as ct, SwipeableProductList as nn } from "@made-people/blueprint-swipeable-product-list";
import { Markdown as on } from "@made-people/blueprint-markdown";
import { GridContext as sn } from "@made-people/blueprint-grid";
import { Breadcrumbs as se, breadcrumbsSchema as rn } from "@made-people/blueprint-breadcrumbs";
import { shippingBarometerSchema as ln, ShippingBarometer as cn } from "@made-people/blueprint-shipping-barometer";
import { NotifyMe as dt } from "@made-people/blueprint-notify-me";
import { StatusInformationIcon as dn } from "@made-people/blueprint-icons";
import { useLink as un } from "@made-people/grease-link";
import "@made-people/blueprint";
const pn = () => /* @__PURE__ */ e(
  "svg",
  {
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 12.9 12.9",
    children: /* @__PURE__ */ e("path", { d: "M7.5,6.5L12.7,1.3c.3-.3.3-.8,0-1.1s-.8-.3-1.1,0l-5.2,5.2L1.3.2C1,0,.5,0,.2.2s-.2.3-.2.5,0,.4.2.5l5.2,5.2L.2,11.6c-.3.3-.3.8,0,1.1s.3.2.5.2.4,0,.5-.2l5.2-5.2,5.2,5.2c.1.1.3.2.5.2s.4,0,.5-.2.2-.3.2-.5,0-.4-.2-.5l-5.2-5.2Z" })
  }
), mn = ({
  children: a,
  CloseIcon: o,
  slots: n
}) => {
  const { isOpen: s, onChange: i } = Da();
  return $(() => {
    i(!0);
  }, []), /* @__PURE__ */ e(le.Root, { defaultOpen: !0, onOpenChange: i, open: s, children: /* @__PURE__ */ p(le.Portal, { children: [
    /* @__PURE__ */ e(le.Overlay, { className: n.modalOverlay }),
    /* @__PURE__ */ p(
      le.Content,
      {
        "aria-description": "Product Page Modal",
        "aria-describedby": "Product",
        className: n.modalContent,
        children: [
          /* @__PURE__ */ e(le.Title, { hidden: !0, children: "Product Page" }),
          /* @__PURE__ */ e(le.Close, { className: n.closeButton, children: o }),
          /* @__PURE__ */ e("section", { className: n.contentWrapper, children: a })
        ]
      }
    )
  ] }) });
}, ut = t.object({
  template: t.literal("drawer"),
  variants: t.custom().optional(),
  children: t.custom(() => !0).optional(),
  drawerSettings: t.custom().optional(),
  closeIcon: t.union([
    t.string(),
    t.custom(),
    t.custom()
  ]).optional()
}), hn = y(
  "ProductDrawer",
  P(
    ut,
    ({ variants: a, children: o, closeIcon: n = pn, drawerSettings: s }) => {
      const i = Zt.styles(a), [c, r] = V(!1);
      $(() => {
        r(window.innerWidth > 1124);
      }, []);
      const l = () => typeof n == "string" || Xt(n) ? n : typeof n == "function" ? /* @__PURE__ */ e(n, {}) : null;
      return c ? /* @__PURE__ */ e(mn, { CloseIcon: l(), slots: i, children: o }) : /* @__PURE__ */ e(
        j,
        {
          ...s,
          defaultOpen: !0,
          direction: "bottom",
          variants: {
            dimmed: "subtle",
            blurred: "subtle",
            background: "none",
            ...s == null ? void 0 : s.variants
          },
          children: /* @__PURE__ */ p(
            j.Content,
            {
              contentSettings: {
                "aria-description": "Content for product popup",
                "aria-describedby": "Product"
              },
              children: [
                /* @__PURE__ */ e(j.Close, { className: i.closeButton, children: l() }),
                /* @__PURE__ */ e(j.Title, { hidden: !0, children: "Product Page popup" }),
                /* @__PURE__ */ e("div", { className: i.drawerWrapper, children: /* @__PURE__ */ e("section", { className: i.contentWrapper, children: o }) })
              ]
            }
          )
        }
      );
    }
  )
), pt = t.object({
  template: t.literal("grid"),
  variants: t.custom().optional(),
  children: t.custom(() => !0).optional()
}), bn = y(
  "ProductGrid",
  P(pt, ({ variants: a, children: o }) => {
    const n = qt.styles(a);
    return /* @__PURE__ */ e("section", { className: n.base, children: o });
  })
), gn = t.discriminatedUnion("template", [
  ut,
  pt
]), fn = y(
  "ProductRoot",
  P(gn, (a) => a.template === "drawer" ? /* @__PURE__ */ e(hn, { ...a }) : a.template === "grid" ? /* @__PURE__ */ e(bn, { ...a }) : null)
), mt = t.object({
  variants: t.custom().optional(),
  text: t.string().optional(),
  blueprint: t.custom().optional(),
  headingTag: t.enum(["h1", "h2", "h3", "h4", "h5", "h6"]).optional(),
  asLink: t.boolean().optional()
}), vn = y(
  "ProductDetailsName",
  P(
    {
      schema: mt,
      defaultProps: {
        headingTag: "h1"
      }
    },
    ({ variants: a, text: o, headingTag: n, asLink: s, ...i }) => {
      const c = O(), {
        content: { name: r }
      } = c, u = (i.blueprint ?? q.main).styles(a), h = n ?? "h1", g = o ?? r;
      return s ? /* @__PURE__ */ e(h, { className: u.name, children: /* @__PURE__ */ e(ye, { productBase: c, context: "product-card", children: g }) }) : /* @__PURE__ */ e(h, { className: u.name, children: g });
    }
  )
), yn = t.object({
  variants: t.custom().optional()
}), Pn = y(
  "ProductDetailsShortDescription",
  P(yn, ({ variants: a }) => {
    const {
      content: { shortDescription: o }
    } = O(), n = q.main.styles(a);
    return o ? /* @__PURE__ */ e("p", { className: n.shortDescription, children: o }) : null;
  })
), Ve = t.object({
  variants: t.custom().optional(),
  text: t.string().optional(),
  readMoreSettings: t.object({
    enabled: t.boolean(),
    limit: t.number().optional()
  }).optional(),
  label: t.string().optional(),
  blueprint: t.custom().optional(),
  formatDotsToList: t.boolean().optional()
}), Sn = y(
  "ProductDetailsDescription",
  P(
    Ve,
    ({
      variants: a,
      readMoreSettings: o,
      text: n,
      label: s,
      formatDotsToList: i,
      ...c
    }) => {
      const {
        content: { description: r }
      } = O(), u = (c.blueprint ?? q.main).styles(a), [h, g] = V(!(o != null && o.enabled)), v = L();
      if (!r && !n)
        return null;
      const _ = n ?? r, w = _.length > ((o == null ? void 0 : o.limit) ?? 200), b = i ? _.split(`
`).map((S) => {
        const f = S.trim();
        return f.startsWith("•") ? `<li>${f.substring(1).trim()}</li>` : f ? `${f}` : "";
      }).join("") : _;
      return /* @__PURE__ */ p("div", { className: u.description, children: [
        s && /* @__PURE__ */ e("h2", { className: u.descriptionLabel, children: s }),
        /* @__PURE__ */ e(
          "p",
          {
            className: h ? "" : "line-clamp-2",
            dangerouslySetInnerHTML: {
              __html: h ? b : `${b.substring(0, 200)}...`
            }
          }
        ),
        (o == null ? void 0 : o.enabled) && w && /* @__PURE__ */ e(
          "button",
          {
            className: u.descriptionReadMoreButton,
            onClick: () => g(!h),
            children: v(h ? "Product_Description_Read_Less" : "Product_Description_Read_More")
          }
        )
      ] });
    }
  )
), wn = t.object({
  variants: t.custom().optional()
}), _n = y(
  "ProductDetailsBrand",
  P(wn, ({ variants: a }) => {
    var c;
    const o = O(), n = q.main.styles(a), i = (c = ee(o)("brandName", t.string())) == null ? void 0 : c.value;
    return i ? /* @__PURE__ */ e("span", { className: n.brand, children: i }) : null;
  })
), ht = t.object({
  drawerSettings: t.custom().optional(),
  trigger: t.custom().optional(),
  isEnabled: t.boolean().optional()
}), kn = 1024, Nn = y(
  "PriceHistoryDrawer",
  P(ht, (a) => {
    var h, g;
    const o = Jt.styles(), n = Pe(), [s, i] = V(!1), c = L(), r = (h = n.previouslyDiscountedPrices) == null ? void 0 : h.find(
      (v) => v.periodDays === 30
    ), l = n.price.formatted !== (r == null ? void 0 : r.price.formatted);
    if ($(() => {
      const v = () => {
        i(window.innerWidth > kn);
      };
      return window.addEventListener("resize", v), v(), () => {
        window.removeEventListener("resize", v);
      };
    }, []), !a.isEnabled)
      return null;
    const u = (g = n.discountInfo) != null && g.percent ? `(-${n.discountInfo.percent}%)` : "";
    return /* @__PURE__ */ p(
      j,
      {
        customOverlayId: "price-history",
        hasOverlay: !0,
        hasScaledBackground: !0,
        setBackgroundColorOnScale: !1,
        header: {
          headingSettings: {
            heading: c("Price_History_Heading")
          }
        },
        hasHandle: !s,
        variants: {
          dragHandle: s ? "false" : "true",
          rounded: s ? "none" : "strong",
          background: "white",
          direction: s ? "right" : "bottom"
        },
        direction: s ? "right" : "bottom",
        ...a.drawerSettings,
        children: [
          l && /* @__PURE__ */ p(j.Trigger, { className: o.trigger, children: [
            /* @__PURE__ */ e(
              "span",
              {
                className: "absolute w-10 h-10",
                tabIndex: -1,
                "aria-hidden": "true"
              }
            ),
            a.trigger
          ] }),
          /* @__PURE__ */ e(j.Content, { children: /* @__PURE__ */ p("div", { className: o.contentWrapper, children: [
            /* @__PURE__ */ p("div", { className: o.priceRow, children: [
              /* @__PURE__ */ e("span", { className: o.priceValue, children: n.price.formatted }),
              u && /* @__PURE__ */ e("span", { className: o.discountBadge, children: c("Price_History_Current_Price", {
                discountPercent: u
              }) })
            ] }),
            r && /* @__PURE__ */ p("div", { className: o.priceRow, children: [
              /* @__PURE__ */ e("span", { className: o.priceValue, children: r.price.formatted }),
              /* @__PURE__ */ e("span", { className: o.priceLabel, children: c("Price_History_Lowest_Price_In_Last_30_Days") })
            ] }),
            /* @__PURE__ */ p("div", { className: o.priceRow, children: [
              /* @__PURE__ */ e("span", { className: o.priceValue, children: n.priceWithoutDiscount.formatted }),
              /* @__PURE__ */ e("span", { className: o.priceLabel, children: c("Price_History_Original_Price") })
            ] })
          ] }) })
        ]
      }
    );
  })
), bt = t.object({
  variants: t.custom().optional(),
  blueprint: t.custom().optional(),
  priceHistoryDrawerSettings: ht.optional()
}), Tn = y(
  "ProductDetailsPrice",
  P(bt, ({ variants: a, ...o }) => {
    const n = Pe(), i = (o.blueprint ?? q.main).styles(a), c = Z(), r = n.price.number < n.priceWithoutDiscount.number;
    return /* @__PURE__ */ e(Q, { children: /* @__PURE__ */ p("div", { className: i.priceWrapper, children: [
      /* @__PURE__ */ e(
        "span",
        {
          "data-is-discounted": r ? "true" : "false",
          className: i.price,
          children: n.price.formatted
        }
      ),
      r && /* @__PURE__ */ p("span", { className: i.oldPrice, children: [
        n.priceWithoutDiscount.formatted,
        /* @__PURE__ */ e(
          m.PriceHistoryDrawer,
          {
            ...o.priceHistoryDrawerSettings
          }
        )
      ] }),
      c === "bundle" && /* @__PURE__ */ e(Cn, {})
    ] }) });
  })
), Cn = () => (Ae(), null), An = t.object({
  variants: t.custom().optional(),
  children: t.custom().optional()
}), Bn = y(
  "ProductDetailsWrapper",
  P(An, ({ variants: a, children: o }) => {
    const n = q.main.styles(a);
    return /* @__PURE__ */ e("section", { className: n.wrapper, children: o });
  })
), pe = t.object({
  variants: t.custom().optional(),
  attributeKey: t.string().optional(),
  className: t.string().optional(),
  label: t.string().optional()
}), Dn = y(
  "ProductDetailsProductType",
  P(
    {
      schema: pe,
      defaultProps: {
        attributeKey: "subHeadline"
      }
    },
    ({ variants: a, attributeKey: o, className: n, label: s }) => {
      var u;
      const i = O(), r = (u = ee(i)(
        o ?? "",
        t.string()
      )) == null ? void 0 : u.value, l = q.main.styles(a);
      if (!(!r && !s))
        return /* @__PURE__ */ e("span", { className: Ea(l.productType, n), children: s ?? r });
    }
  )
), Ue = Ga.extend({
  content: t.object({
    value: t.string().optional(),
    attributeKey: t.string().optional(),
    trigger: t.custom().optional(),
    content: t.custom().optional(),
    forceMount: t.boolean().optional()
  })
}), In = t.object({
  variants: t.custom().optional(),
  items: t.array(Ue).optional(),
  settings: Wa.omit({ items: !0 }).optional()
}), Ln = y(
  "ProductDetailsAccordion",
  P(In, ({ variants: a, items: o, settings: n }) => {
    const s = O(), i = ee(s), c = q.main.styles(a), r = o == null ? void 0 : o.map((l) => {
      var h;
      let u = l.content.content;
      if (l.content.attributeKey) {
        const g = (h = i(
          l.content.attributeKey,
          t.string()
        )) == null ? void 0 : h.value;
        if (!u && !g)
          return null;
        u = g ?? u;
      }
      return u ? {
        ...l,
        content: {
          content: u,
          value: l.content.value,
          trigger: l.content.trigger,
          forceMount: l.content.forceMount
        }
      } : null;
    }).filter((l) => l !== null);
    return r ? /* @__PURE__ */ e("div", { className: c.accordionWrapper, children: /* @__PURE__ */ e(
      Oa,
      {
        ...n,
        blueprint: q.accordion,
        layout: {
          spacing: {
            applySpacing: "false"
          },
          position: {
            applyPosition: "false"
          }
        },
        items: r
      }
    ) }) : null;
  })
), zn = {
  Name: vn,
  ShortDescription: Pn,
  Brand: _n,
  Price: Tn,
  Wrapper: Bn,
  Description: Sn,
  ProductType: Dn,
  Accordion: Ln
  // Add other components as needed
}, xn = t.object({
  className: t.string().optional(),
  badgeSettings: st.optional(),
  hide: t.boolean().optional()
}), Rn = ({
  badgeSettings: a,
  hide: o,
  className: n
}) => {
  const s = L(), i = Ae(), c = i.discountFromPriceOfItemsOutsideBundle.formatted, r = i.discountFromPriceOfItemsOutsideBundle.number;
  return o || !c || r <= 0 ? null : /* @__PURE__ */ e("div", { className: n, children: /* @__PURE__ */ e(
    Ke,
    {
      ...a,
      label: s("PDP_Bundle_Savings_Badge", { bundleSavings: c })
    }
  ) });
}, gt = y(
  "BundleSavingsBadge",
  P(xn, (a) => Z() !== "bundle" ? null : /* @__PURE__ */ e(Rn, { ...a }))
), En = t.object({
  subHeadlineAttribute: t.string().optional(),
  variants: t.custom().optional()
}), Gn = y(
  "ShopTheLookItem",
  P(
    {
      schema: En,
      defaultProps: {
        subHeadlineAttribute: "subHeadline"
      }
    },
    ({ subHeadlineAttribute: a, variants: o }) => {
      var v;
      const n = O(), s = Ia(), i = Pe(), c = Z(), r = ee(n), l = ea.styles(o), u = s == null ? void 0 : s[0], h = i.price.number < i.priceWithoutDiscount.number, g = a ? (v = r(a, t.string())) == null ? void 0 : v.value : void 0;
      return /* @__PURE__ */ p("div", { className: l.wrapper, children: [
        /* @__PURE__ */ p("div", { className: l.contentWrapper, children: [
          u && /* @__PURE__ */ e(
            ye,
            {
              productBase: n,
              context: "product-card",
              className: l.imageWrapper,
              children: /* @__PURE__ */ e(te, { className: l.image, image: u })
            }
          ),
          /* @__PURE__ */ p("div", { className: l.info, children: [
            /* @__PURE__ */ e("h4", { className: l.productName, children: n.content.name }),
            g && /* @__PURE__ */ e("p", { className: l.productType, children: g }),
            /* @__PURE__ */ p("div", { className: l.priceWrapper, children: [
              /* @__PURE__ */ e(
                "span",
                {
                  "data-is-discounted": h ? "true" : "false",
                  className: l.price,
                  children: i.price.formatted
                }
              ),
              h && /* @__PURE__ */ e("span", { className: l.priceBeforeDiscount, children: i.priceWithoutDiscount.formatted })
            ] })
          ] })
        ] }),
        c === "with_variants" && /* @__PURE__ */ e(m.SizePicker, { template: "button-grid" }),
        /* @__PURE__ */ e(
          m.AddToCart,
          {
            template: "button",
            postAddAction: "none",
            buttonSettings: {
              variants: {
                width: "full"
              }
            }
          }
        )
      ] });
    }
  )
), $e = "shop_the_look", Wn = t.object({
  media: t.custom().optional(),
  className: t.string().optional(),
  variants: t.custom().optional(),
  drawerSettings: t.custom().optional(),
  closeIcon: t.custom().optional(),
  triggerIcon: t.custom().optional(),
  showProductCountAsSuffix: t.boolean().optional()
}), On = () => {
  const [a, o] = V(
    typeof window < "u" ? window.innerWidth > 1024 : !1
  );
  return $(() => {
    const n = () => {
      o(window.innerWidth > 1024);
    };
    return window.addEventListener("resize", n), () => window.removeEventListener("resize", n);
  }, []), a;
}, ft = y(
  "ShopTheLook",
  P(
    {
      schema: Wn,
      defaultProps: {}
    },
    ({
      media: a,
      className: o = "",
      variants: n,
      drawerSettings: s,
      closeIcon: i,
      triggerIcon: c,
      showProductCountAsSuffix: r
    }) => {
      const [l, u] = V(!1), h = On(), g = Oe(
        a || {
          type: "image",
          src: "",
          alt: ""
        }
      ), v = (a == null ? void 0 : a.type) === "image" && g($e, t.boolean()), _ = ta.styles(n), w = Be("look"), b = L();
      if (!v || v.value !== !0 || !w.length)
        return null;
      const S = () => {
        Va.emit("featureInteraction", {
          feature: "shop_the_look",
          action: "clicked"
        });
      };
      return /* @__PURE__ */ p(
        j,
        {
          open: l,
          onOpenChange: u,
          direction: h ? "right" : "bottom",
          variants: {
            rounded: "subtle"
          },
          ...s,
          children: [
            /* @__PURE__ */ e(
              j.Trigger,
              {
                className: o || _.trigger,
                onClick: S,
                "aria-label": `Shop The Look - ${w.length} ${w.length === 1 ? "product" : "products"}`,
                children: /* @__PURE__ */ p("div", { className: _.triggerContent, children: [
                  b("Shop_The_Look_Trigger"),
                  c
                ] })
              }
            ),
            /* @__PURE__ */ p(j.Content, { children: [
              /* @__PURE__ */ e(j.Title, { hidden: !0, children: b("Shop_The_Look_Heading") }),
              /* @__PURE__ */ p("div", { className: _.wrapper, children: [
                /* @__PURE__ */ p("div", { className: _.header, children: [
                  /* @__PURE__ */ e(
                    Ua,
                    {
                      heading: b("Shop_The_Look_Heading"),
                      suffix: r ? String(w.length) : void 0,
                      variants: { headingSize: "lg" }
                    }
                  ),
                  /* @__PURE__ */ e(j.Close, { className: _.close, children: i ?? b("Shop_The_Look_Close") })
                ] }),
                /* @__PURE__ */ e("div", { className: _.productList, children: w.map((f, D) => /* @__PURE__ */ e(
                  Ha,
                  {
                    additionalData: {
                      source: "shop-the-look",
                      item_list_id: "shop-the-look",
                      item_list_name: "Shop The Look"
                    },
                    children: /* @__PURE__ */ e(
                      je,
                      {
                        product: f.product,
                        context: {
                          type: "plp",
                          listId: "shop-the-look",
                          listName: "Shop The Look",
                          position: D
                        },
                        children: /* @__PURE__ */ e(Gn, {})
                      }
                    )
                  },
                  f.product.base.productId
                )) })
              ] })
            ] })
          ]
        }
      );
    }
  )
), vt = {
  mobile: "150vw",
  tablet: "150vw",
  desktop: "100vw"
}, qe = 60, jn = 300, Mn = 30, Hn = 10, Kn = 500, Re = (a, o, n) => Math.max(o, Math.min(n, a)), Je = (a, o) => Math.hypot(a.clientX - o.clientX, a.clientY - o.clientY);
function yt({
  enabled: a = !1,
  maxScale: o = 2.5,
  onZoomChange: n,
  onSwipeAtEdge: s,
  hideCursor: i = !1,
  resetOnMouseLeave: c = !1
} = {}) {
  const [r, l] = W.useState(
    null
  ), u = W.useRef(null), h = W.useRef(null), [g, v] = W.useState(!1), [_, w] = W.useState(!1), [b, S] = W.useState(!1), f = W.useRef({ onZoomChange: n, onSwipeAtEdge: s });
  f.current = { onZoomChange: n, onSwipeAtEdge: s };
  const D = W.useRef({
    scale: 1,
    tx: 0,
    ty: 0,
    gesture: { type: "idle" },
    rect: null,
    pinchAnchor: null,
    zoomedFlag: !1,
    lastTapAt: 0,
    lastTapX: 0,
    lastTapY: 0,
    lastTouchEndAt: 0,
    tapStartX: 0,
    tapStartY: 0
  }), C = W.useCallback(() => {
    var R, E;
    const d = D.current;
    d.gesture = { type: "idle" }, d.scale = 1, d.tx = 0, d.ty = 0;
    const z = u.current;
    z && (z.style.transition = "transform 250ms", z.style.transform = "translate(0px, 0px) scale(1)"), d.zoomedFlag && (d.zoomedFlag = !1, v(!1), (E = (R = f.current).onZoomChange) == null || E.call(R, !1));
  }, []);
  W.useEffect(() => {
    if (!a || !r)
      return;
    const d = D.current, z = () => {
      d.rect = r.getBoundingClientRect();
    }, R = (k) => {
      const B = u.current;
      B && (d.rect && (d.tx = Re(d.tx, d.rect.width * (1 - d.scale), 0), d.ty = Re(d.ty, d.rect.height * (1 - d.scale), 0)), B.style.transition = k ? "transform 250ms" : "none", B.style.transform = `translate(${d.tx}px, ${d.ty}px) scale(${d.scale})`);
    }, E = (k) => {
      var B, T;
      d.zoomedFlag !== k && (d.zoomedFlag = k, k && w(!0), v(k), (T = (B = f.current).onZoomChange) == null || T.call(B, k));
    }, M = (k, B, T, H) => {
      if (!d.rect)
        return;
      const ne = k - d.rect.left, re = B - d.rect.top;
      d.scale = T, d.tx = -ne * (T - 1), d.ty = -re * (T - 1), R(H);
    }, F = (k, B) => {
      const T = h.current;
      !T || !d.rect || (T.style.transform = `translate(${k - d.rect.left}px, ${B - d.rect.top}px) translate(-50%, -50%)`);
    };
    z();
    const Y = (k) => {
      z();
      const B = d.rect;
      if (!B)
        return;
      const T = k.touches[0], H = k.touches[1];
      k.touches.length === 2 && T && H ? (k.preventDefault(), k.stopPropagation(), d.pinchAnchor || (d.pinchAnchor = { scale: d.scale, tx: d.tx, ty: d.ty }), d.gesture = {
        type: "pinch",
        startDist: Je(T, H),
        startScale: d.scale,
        startTx: d.tx,
        startTy: d.ty,
        anchorX: (T.clientX + H.clientX) / 2 - B.left,
        anchorY: (T.clientY + H.clientY) / 2 - B.top
      }) : k.touches.length === 1 && T && d.scale > 1 ? (k.preventDefault(), k.stopPropagation(), d.gesture = {
        type: "pan",
        startX: T.clientX,
        startY: T.clientY,
        startTx: d.tx,
        startTy: d.ty
      }, d.tapStartX = T.clientX, d.tapStartY = T.clientY) : (d.gesture = { type: "idle" }, T && (d.tapStartX = T.clientX, d.tapStartY = T.clientY));
    }, N = (k) => {
      var ne, re, ke, Qe;
      const B = d.gesture;
      if (B.type === "idle")
        return;
      k.preventDefault(), k.stopPropagation();
      const T = k.touches[0], H = k.touches[1];
      if (B.type === "pinch" && T && H && B.startDist > 0) {
        const be = Je(T, H) / B.startDist, Ne = Re(B.startScale * be, 1, o), Te = Ne / B.startScale;
        d.scale = Ne, d.tx = B.anchorX - (B.anchorX - B.startTx) * Te, d.ty = B.anchorY - (B.anchorY - B.startTy) * Te, R(!1);
      } else if (B.type === "pan" && T) {
        const be = B.startTx + (T.clientX - B.startX), Ne = B.startTy + (T.clientY - B.startY);
        if (d.tx = be, d.ty = Ne, R(!1), d.rect && d.scale > 1) {
          const Te = d.rect.width * (1 - d.scale);
          if (be > qe) {
            (re = (ne = f.current).onSwipeAtEdge) == null || re.call(ne, "prev"), C();
            return;
          }
          if (be < Te - qe) {
            (Qe = (ke = f.current).onSwipeAtEdge) == null || Qe.call(ke, "next"), C();
            return;
          }
        }
      }
    }, I = (k) => {
      const B = d.gesture;
      if (k.touches.length === 0) {
        if (d.lastTouchEndAt = Date.now(), d.pinchAnchor) {
          const H = d.pinchAnchor;
          d.pinchAnchor = null, d.gesture = { type: "idle" }, d.scale = H.scale, d.tx = H.tx, d.ty = H.ty, R(!0), E(H.scale > 1);
          return;
        }
        const T = k.changedTouches[0];
        if (T && (B.type === "pan" || B.type === "idle") && Math.hypot(
          T.clientX - d.tapStartX,
          T.clientY - d.tapStartY
        ) < Hn) {
          const ne = Date.now(), re = ne - d.lastTapAt, ke = Math.hypot(
            T.clientX - d.lastTapX,
            T.clientY - d.lastTapY
          );
          re < jn && ke < Mn ? (d.lastTapAt = 0, d.scale > 1 ? C() : (M(T.clientX, T.clientY, o, !0), E(!0))) : (d.lastTapAt = ne, d.lastTapX = T.clientX, d.lastTapY = T.clientY), d.gesture = { type: "idle" };
          return;
        }
        E(d.scale > 1), d.gesture = { type: "idle" };
      } else if (k.touches.length === 1 && B.type === "pinch") {
        const T = k.touches[0];
        d.scale > 1 && T ? d.gesture = {
          type: "pan",
          startX: T.clientX,
          startY: T.clientY,
          startTx: d.tx,
          startTy: d.ty
        } : d.gesture = { type: "idle" };
      }
    }, ae = (k) => {
      Date.now() - d.lastTouchEndAt < Kn || (d.scale > 1 ? C() : (M(k.clientX, k.clientY, o, !0), E(!0)));
    }, he = (k) => {
      F(k.clientX, k.clientY), !(d.scale <= 1) && M(k.clientX, k.clientY, d.scale, !1);
    }, _e = (k) => {
      z(), F(k.clientX, k.clientY), S(!0);
    }, X = () => {
      S(!1), c && C();
    };
    return r.addEventListener("touchstart", Y, {
      passive: !1
    }), r.addEventListener("touchmove", N, { passive: !1 }), r.addEventListener("touchend", I, { passive: !1 }), r.addEventListener("touchcancel", I, { passive: !1 }), r.addEventListener("click", ae), r.addEventListener("mousemove", he), r.addEventListener("mouseenter", _e), r.addEventListener("mouseleave", X), window.addEventListener("resize", z), window.addEventListener("scroll", z, {
      passive: !0,
      capture: !0
    }), () => {
      r.removeEventListener("touchstart", Y), r.removeEventListener("touchmove", N), r.removeEventListener("touchend", I), r.removeEventListener("touchcancel", I), r.removeEventListener("click", ae), r.removeEventListener("mousemove", he), r.removeEventListener("mouseenter", _e), r.removeEventListener("mouseleave", X), window.removeEventListener("resize", z), window.removeEventListener("scroll", z, { capture: !0 });
    };
  }, [a, r, o, c, C]);
  const x = W.useCallback(
    (d) => {
      a && l(d);
    },
    [a]
  ), A = W.useCallback((d) => {
    u.current = d, d && (d.style.transformOrigin = "0 0", d.style.willChange = "transform", d.style.transform = "translate(0px, 0px) scale(1)");
  }, []), G = W.useCallback((d) => {
    h.current = d;
  }, []);
  return {
    containerRef: x,
    contentRef: A,
    cursorRef: G,
    containerProps: a ? {
      style: {
        touchAction: g ? "none" : "pan-y",
        cursor: i && b ? "none" : void 0
      }
    } : {},
    isZoomed: g,
    hasBeenZoomed: _,
    isHovering: b,
    reset: C
  };
}
const Pt = ({
  cursorRef: a,
  Cursor: o,
  isZoomed: n,
  isHovering: s
}) => /* @__PURE__ */ e(
  "div",
  {
    ref: a,
    "aria-hidden": "true",
    className: "absolute left-0 top-0 pointer-events-none will-change-transform",
    children: /* @__PURE__ */ e(o, { isZoomed: n, isHovering: s })
  }
), Le = t.object({
  template: t.literal("keen"),
  variants: t.custom().optional(),
  indicator: t.literal("number").or(t.literal("dots")).optional(),
  navigation: t.object({
    enabled: t.object({
      mobile: t.boolean().optional().default(!1),
      tablet: t.boolean().optional().default(!1),
      desktop: t.boolean().optional().default(!1)
    }),
    prevIcon: t.custom().optional(),
    nextIcon: t.custom().optional()
  }).optional(),
  slidesPerView: t.object({
    mobile: t.number().optional(),
    tablet: t.number().optional(),
    desktop: t.number().optional()
  }).optional(),
  gap: t.object({
    mobile: t.number().optional(),
    tablet: t.number().optional(),
    desktop: t.number().optional()
  }).optional(),
  children: t.custom().optional(),
  buttonInSlider: t.object({
    enabled: t.boolean().optional(),
    onClick: t.custom().optional(),
    label: t.string().optional()
  }).optional(),
  blueprint: t.custom().optional(),
  videoSettings: Ma.optional(),
  customComponent: t.custom().optional(),
  zoom: t.boolean().optional(),
  zoomCursor: t.custom().optional()
}), Vn = y(
  "ImageGalleryAsKeen",
  P(
    Le,
    ({
      variants: a,
      indicator: o,
      navigation: n,
      slidesPerView: s,
      gap: i,
      children: c,
      buttonInSlider: r,
      videoSettings: l,
      customComponent: u,
      zoom: h,
      zoomCursor: g,
      ...v
    }) => {
      var M, F, Y;
      const {
        content: { media: _ }
      } = O(), b = (v.blueprint ?? aa).styles(a), [S, f] = W.useState(0);
      function D(N) {
        return (I) => {
          function ae() {
            I.slides.forEach((X) => {
              X.classList.remove("active");
            });
          }
          function he(X) {
            I.slides[X].classList.add("active");
          }
          function _e() {
            I.slides.forEach((X, k) => {
              X.addEventListener("click", () => {
                N.current && N.current.moveToIdx(k);
              });
            });
          }
          I.on("created", () => {
            N.current && (he(I.track.details.rel), _e(), N.current.on("animationStarted", (X) => {
              ae();
              const k = X.animator.targetIdx || 0;
              he(X.track.absToRel(k)), I.moveToIdx(Math.min(I.track.details.maxIdx, k));
            }));
          });
        };
      }
      const C = et(_, {
        key: ot,
        value: [!1, void 0]
      }), A = (C == null ? void 0 : C.length) === 1, G = W.useMemo(
        () => C.map((N) => N.src).join(","),
        [C]
      ), [U, d] = Ze({
        selector: ".keen-slider__slide",
        mode: "snap",
        loop: !A,
        breakpoints: {
          "(min-width: 0px)": {
            slides: {
              perView: A ? 1 : (s == null ? void 0 : s.mobile) ?? 1,
              spacing: (i == null ? void 0 : i.mobile) ?? 12
            }
          },
          "(min-width: 640px)": {
            slides: {
              perView: A ? 1 : (s == null ? void 0 : s.tablet) ?? 1,
              spacing: (i == null ? void 0 : i.tablet) ?? 24
            }
          },
          "(min-width: 1024px)": {
            slides: {
              perView: A ? 1 : (s == null ? void 0 : s.desktop) ?? 1,
              spacing: (i == null ? void 0 : i.desktop) ?? 20
            }
          }
        },
        slideChanged(N) {
          f(N.track.details.rel);
        }
      });
      W.useEffect(() => {
        f(0);
      }, [G]);
      const [z] = Ze(
        {
          initial: 0,
          slides: {
            perView: "auto",
            spacing: 4
          }
        },
        [D(d)]
      ), R = ja({
        mobile: (M = n == null ? void 0 : n.enabled) == null ? void 0 : M.mobile,
        tablet: (F = n == null ? void 0 : n.enabled) == null ? void 0 : F.tablet,
        desktop: (Y = n == null ? void 0 : n.enabled) == null ? void 0 : Y.desktop
      }), E = W.useCallback(
        (N) => {
          const I = d.current;
          I && (N === "next" ? I.next() : I.prev());
        },
        []
      );
      return /* @__PURE__ */ p(
        "div",
        {
          className: b.base,
          "data-button-in-slider": (r == null ? void 0 : r.enabled) ?? !1,
          children: [
            /* @__PURE__ */ e(gt, { className: b.bundleSavingsBadge }),
            /* @__PURE__ */ p(
              "div",
              {
                ref: U,
                className: `keen-slider ${b.galleryWrapper}`,
                children: [
                  c,
                  C.map((N, I) => N ? /* @__PURE__ */ e(
                    Un,
                    {
                      media: N,
                      position: I,
                      index: I,
                      slots: b,
                      currentSlide: S,
                      videoSettings: l,
                      zoom: h,
                      zoomCursor: g,
                      onSwipeAtEdge: E
                    },
                    `${N.src}-${I}`
                  ) : null),
                  u && u,
                  (r == null ? void 0 : r.enabled) && (r == null ? void 0 : r.onClick) && (r == null ? void 0 : r.label) && /* @__PURE__ */ e(
                    "button",
                    {
                      className: b.linkButton,
                      onClick: r.onClick,
                      children: r.label
                    }
                  ),
                  o === "number" && /* @__PURE__ */ p("span", { className: b.numberIndicator, children: [
                    "[ ",
                    S + 1,
                    " / ",
                    C.length,
                    " ]"
                  ] }),
                  o === "dots" && /* @__PURE__ */ e("span", { className: b.dotsIndicatorWrapper, children: C.map((N, I) => /* @__PURE__ */ e(
                    "button",
                    {
                      "data-is-active": S === I ? "true" : "false",
                      onClick: () => {
                        var ae;
                        return (ae = d.current) == null ? void 0 : ae.moveToIdx(I);
                      },
                      className: b.dotsIndicator
                    },
                    I
                  )) }),
                  !A && (n == null ? void 0 : n.prevIcon) && (n == null ? void 0 : n.nextIcon) && /* @__PURE__ */ p("div", { className: b.arrowsWrapper, ...R, children: [
                    /* @__PURE__ */ e(
                      "button",
                      {
                        className: b.leftArrow,
                        onClick: () => {
                          var N;
                          return (N = d.current) == null ? void 0 : N.prev();
                        },
                        children: n == null ? void 0 : n.prevIcon
                      }
                    ),
                    /* @__PURE__ */ e(
                      "button",
                      {
                        className: b.rightArrow,
                        onClick: () => {
                          var N;
                          return (N = d.current) == null ? void 0 : N.next();
                        },
                        children: n == null ? void 0 : n.nextIcon
                      }
                    )
                  ] })
                ]
              },
              G
            ),
            C.length > 1 && /* @__PURE__ */ e(
              "div",
              {
                ref: z,
                className: `keen-slider thumbnail ${b.thumbnailWrapper}`,
                children: C.map((N, I) => /* @__PURE__ */ e(
                  "div",
                  {
                    "data-is-active": S === I ? "true" : "false",
                    className: `keen-slider__slide relative ${b.thumbnail}`,
                    children: N.type === "image" && /* @__PURE__ */ e(
                      te,
                      {
                        image: { src: N.src, alt: (N == null ? void 0 : N.alt) ?? "dada" },
                        className: "w-full h-full"
                      }
                    )
                  },
                  `${N.src}-${I}`
                ))
              }
            )
          ]
        }
      );
    }
  )
), Un = ({
  currentSlide: a,
  position: o,
  index: n,
  media: s,
  slots: i,
  videoSettings: c,
  zoom: r,
  zoomCursor: l,
  onSwipeAtEdge: u
}) => {
  const h = a !== n, g = Oe(s), v = s.type === "image" && g("model_is_wearing", t.string()), _ = s.type === "image" && g($e, t.boolean()), w = !!r && s.type === "image", {
    containerRef: b,
    contentRef: S,
    cursorRef: f,
    containerProps: D,
    isZoomed: C,
    hasBeenZoomed: x,
    isHovering: A,
    reset: G
  } = yt({
    enabled: w,
    onSwipeAtEdge: u,
    hideCursor: !!l
  });
  if (W.useEffect(() => {
    a !== n && C && G();
  }, [a, n, C, G]), !s)
    return null;
  const U = s.type === "image" && /* @__PURE__ */ e(
    te,
    {
      image: { src: s.src, alt: s.alt },
      className: i.image,
      fetchpriority: o < 2 ? "high" : "auto",
      loading: o < 2 ? "eager" : "lazy",
      displaySize: x ? vt : { mobile: "50vw", tablet: "80vw", desktop: "40vw" }
    }
  );
  return /* @__PURE__ */ p(
    "div",
    {
      ref: b,
      ...D,
      "data-is-active": a === n ? "true" : "false",
      className: `keen-slider__slide ${i.imageWrapper} relative`,
      children: [
        s.type !== "image" ? /* @__PURE__ */ e(nt, { src: s.src, loop: !0, autoPlay: !0, ...c }) : w ? /* @__PURE__ */ e("div", { ref: S, className: "w-full h-full", children: U }) : U,
        w && l && /* @__PURE__ */ e(
          Pt,
          {
            cursorRef: f,
            Cursor: l,
            isZoomed: C,
            isHovering: A
          }
        ),
        v && /* @__PURE__ */ e("div", { className: i.modelIsWearing, children: v.value }),
        _ && /* @__PURE__ */ e(ft, { media: s, className: i.shopTheLook }),
        h && /* @__PURE__ */ e("div", { className: i.peekingImage })
      ]
    },
    n
  );
}, St = t.object({
  template: t.literal("grid"),
  variants: t.custom().optional(),
  imageSettings: at.optional(),
  CustomComponent: t.custom().optional(),
  zoom: t.boolean().optional(),
  zoomCursor: t.custom().optional()
}), $n = y(
  "ImageGalleryAsGrid",
  P(
    St,
    ({ variants: a, imageSettings: o, CustomComponent: n, zoom: s, zoomCursor: i }) => {
      const {
        content: { media: c }
      } = O(), r = na.styles(a), l = et(c, {
        key: ot,
        value: [!1, void 0]
      });
      return /* @__PURE__ */ p("div", { className: r.base, children: [
        /* @__PURE__ */ e(gt, { className: r.bundleSavingsBadge }),
        l.map(
          (u, h) => u && /* @__PURE__ */ e(
            Fn,
            {
              media: u,
              CustomComponent: n,
              position: h,
              slots: r,
              imageSettings: o,
              amountOfImages: l.length,
              zoom: s,
              zoomCursor: i
            },
            h
          )
        )
      ] });
    }
  )
), Fn = ({
  media: a,
  slots: o,
  position: n,
  amountOfImages: s,
  imageSettings: i,
  CustomComponent: c,
  zoom: r,
  zoomCursor: l
}) => {
  const u = Oe(a), h = a.type === "image" && u("model_is_wearing", t.string()), g = a.type === "image" && u($e, t.boolean()), v = n === s - 1, _ = s % 2 !== 0, w = !!r && a.type === "image", {
    containerRef: b,
    contentRef: S,
    cursorRef: f,
    containerProps: D,
    isZoomed: C,
    hasBeenZoomed: x,
    isHovering: A
  } = yt({
    enabled: w,
    hideCursor: !!l,
    resetOnMouseLeave: !0
  }), G = a.type === "image" && /* @__PURE__ */ e(
    te,
    {
      image: { src: a.src, alt: a.alt },
      className: o.image,
      fetchpriority: n < 5 ? "high" : "auto",
      loading: n < 5 ? "eager" : "lazy",
      ...i,
      displaySize: x ? vt : (i == null ? void 0 : i.displaySize) ?? {
        mobile: "90vw",
        tablet: "90vw",
        desktop: _ && v ? "60vw" : "25vw"
      }
    }
  );
  return /* @__PURE__ */ p(
    "div",
    {
      className: o.imageWrapper,
      "data-has-shop-the-look": g ? "true" : "false",
      "data-has-model-is-wearing": h ? "true" : "false",
      "data-position": n,
      children: [
        w ? /* @__PURE__ */ p(
          "div",
          {
            ref: b,
            ...D,
            className: "absolute inset-0 overflow-hidden",
            children: [
              /* @__PURE__ */ e("div", { ref: S, className: "w-full h-full", children: G }),
              l && /* @__PURE__ */ e(
                Pt,
                {
                  cursorRef: f,
                  Cursor: l,
                  isZoomed: C,
                  isHovering: A
                }
              )
            ]
          }
        ) : a.type === "image" ? G : /* @__PURE__ */ e(nt, { src: a.src, loop: !0, autoPlay: !0 }),
        h && /* @__PURE__ */ e("div", { className: o.modelIsWearing, children: h.value }),
        g && /* @__PURE__ */ e(ft, { media: a, className: o.shopTheLook }),
        c && /* @__PURE__ */ e(c, { position: n, amountOfImages: s })
      ]
    }
  );
}, wt = t.discriminatedUnion("template", [
  Le,
  St
]), Yn = y(
  "ImageGallery",
  P(wt, (a) => a.template === "keen" ? /* @__PURE__ */ e(Vn, { ...a }) : a.template === "grid" ? /* @__PURE__ */ e($n, { ...a }) : null)
), _t = t.object({
  template: t.literal("table"),
  variants: t.custom().optional(),
  groupId: t.string().optional(),
  content: t.object({
    heading: t.string().optional(),
    headingTag: t.union([
      t.literal("h1"),
      t.literal("h2"),
      t.literal("h3"),
      t.literal("h4"),
      t.literal("h5"),
      t.literal("h6")
    ]).optional()
  }).optional()
}), Xn = y(
  "ProductSpecificationsAsTable",
  P(
    {
      schema: _t,
      defaultProps: {
        template: "table",
        groupId: "pdp_specifications"
      }
    },
    ({ variants: a, content: o, groupId: n }) => {
      const s = oa.styles(a), i = (o == null ? void 0 : o.headingTag) || "h3", c = La(
        n ?? "pdp_specifications"
      );
      return !c || !c.length ? null : /* @__PURE__ */ p("div", { className: s.base, children: [
        (o == null ? void 0 : o.heading) && /* @__PURE__ */ e(i, { className: s.heading, children: o.heading }),
        /* @__PURE__ */ e("ol", { className: s.tableWrapper, children: c.map((r, l) => /* @__PURE__ */ p("li", { className: s.row, children: [
          /* @__PURE__ */ p("span", { className: s.label, children: [
            (r == null ? void 0 : r.icon) && /* @__PURE__ */ e("span", { className: s.icon, children: r.icon }),
            r.label
          ] }),
          /* @__PURE__ */ e("span", { className: s.value, children: r.value })
        ] }, l)) })
      ] });
    }
  )
), kt = t.discriminatedUnion("template", [
  _t
]), Qn = y(
  "ProductSpecifications",
  P(kt, (a) => a.template === "table" ? /* @__PURE__ */ e(Xn, { ...a }) : null)
), Zn = t.object({
  label: t.string(),
  barColor: t.string().optional(),
  /**
   * The key for the attribute.
   * @type {string}
   */
  attributeKey: t.string()
}), Fe = t.object({
  template: t.literal("progress-bar"),
  variants: t.custom().optional(),
  features: t.object({
    /** On a scale of. @default 10 */
    onAScaleOf: t.number()
  }).optional(),
  items: Zn.array().optional()
}), qn = y(
  "AttributesAsProgressBar",
  P(
    Fe,
    ({
      variants: a,
      features: o = {
        onAScaleOf: 10
      },
      items: n
    }) => {
      const s = sa.styles(a), i = O(), c = ee(i);
      if (!n)
        return null;
      const r = n.map((l) => {
        var h;
        const u = (h = c(l.attributeKey, t.string())) == null ? void 0 : h.value;
        if (u)
          return {
            label: l.label,
            score: parseInt(u),
            barColor: l.barColor
          };
      }).filter($a);
      return r.length === 0 ? null : /* @__PURE__ */ e("div", { className: s.base, children: r.map((l, u) => /* @__PURE__ */ p("div", { className: s.item, children: [
        /* @__PURE__ */ e("div", { className: s.label, children: l.label }),
        /* @__PURE__ */ e("div", { className: s.bar, children: /* @__PURE__ */ e(
          J.div,
          {
            className: s.barFill,
            initial: { width: 0 },
            whileInView: {
              width: `${l.score / o.onAScaleOf * 100}%`
            },
            exit: { width: 0 },
            transition: { delay: u * 0.16 },
            style: {
              backgroundColor: l.barColor
            }
          }
        ) }),
        /* @__PURE__ */ p("div", { className: s.scoreLabel, children: [
          l.score,
          "/",
          o.onAScaleOf
        ] })
      ] }, u)) });
    }
  )
), qs = t.string(), Ye = t.object({
  template: t.literal("tags"),
  variants: t.custom().optional(),
  /**
   * The key for the attribute on the product.
   */
  attributeKey: t.string(),
  label: t.string().optional(),
  features: t.object({}).optional()
}), Jn = y(
  "AttributesAsTags",
  P(Ye, ({ variants: a, attributeKey: o, label: n }) => {
    const s = ia.styles(a), i = K(
      o,
      t.union([
        t.string(),
        t.array(t.string()),
        t.array(t.object({ description: t.string() }))
      ])
    );
    if (!i)
      return null;
    const c = Array.isArray(i.value) ? i.value : [i.value];
    return c.length ? /* @__PURE__ */ p("div", { className: s.base, children: [
      n && /* @__PURE__ */ e("span", { className: s.label, children: n }),
      /* @__PURE__ */ e("div", { className: s.tags, children: c.map((r, l) => /* @__PURE__ */ e("div", { className: s.tag, children: typeof r == "object" ? r.description : r }, `${r}-${l}`)) })
    ] }) : null;
  })
), Nt = t.object({
  template: t.literal("icon-blocks"),
  variants: t.custom().optional(),
  /**
   * The key for the attribute on the product.
   */
  attributeKey: t.string(),
  label: t.string().optional(),
  features: t.object({}).optional(),
  link: Fa.optional()
}), eo = y(
  "AttributesAsIconBlocks",
  P(
    Nt,
    ({ variants: a, attributeKey: o, label: n, link: s }) => {
      var r, l;
      const i = ra.styles(a), c = (r = K(
        o,
        t.array(
          t.object({
            description: t.string().optional(),
            image: t.object({
              url: t.string()
            }).optional()
          })
        )
      )) == null ? void 0 : r.value;
      if (c)
        return /* @__PURE__ */ p("div", { className: i.base, children: [
          /* @__PURE__ */ p("div", { className: i.header, children: [
            n && /* @__PURE__ */ e("span", { className: i.label, children: n }),
            ((l = s == null ? void 0 : s.link) == null ? void 0 : l.href) && /* @__PURE__ */ e(Ya, { as: "a", className: i.link, ...s })
          ] }),
          /* @__PURE__ */ e("div", { className: i.blocks, children: c.map(
            (u, h) => {
              var g;
              return (g = u.image) != null && g.url ? /* @__PURE__ */ p(
                "div",
                {
                  className: i.block,
                  children: [
                    /* @__PURE__ */ e(
                      te,
                      {
                        className: i.icon,
                        image: {
                          src: u.image.url,
                          alt: u.description
                        }
                      }
                    ),
                    /* @__PURE__ */ e("span", { className: i.description, children: u.description })
                  ]
                },
                `${u.description}-${h}`
              ) : null;
            }
          ) })
        ] });
    }
  )
), Tt = t.object({
  template: t.literal("row"),
  variants: t.custom().optional(),
  /**
   * The key for the attribute on the product.
   */
  attributeKey: t.string().optional(),
  data: t.object({
    attributeLabel: t.string().optional(),
    value: t.string().optional().or(t.custom().optional())
  }).optional()
}), Ct = ({
  variants: a,
  content: o
}) => {
  const n = la.styles(a), s = L();
  return /* @__PURE__ */ p("div", { className: n.base, children: [
    o.attributeLabel && /* @__PURE__ */ e("label", { className: n.label, children: s(o.attributeLabel) }),
    /* @__PURE__ */ e("h4", { className: n.value, children: o.value })
  ] });
}, to = ({
  variants: a,
  attributeKey: o,
  data: n
}) => {
  const i = K(o, t.string()) ?? n;
  return i ? /* @__PURE__ */ e(Ct, { variants: a, content: i }) : null;
}, ao = y(
  "AttributesAsRow",
  P(Tt, ({ variants: a, attributeKey: o, data: n }) => o ? /* @__PURE__ */ e(
    to,
    {
      variants: a,
      attributeKey: o,
      data: n
    }
  ) : n ? /* @__PURE__ */ e(Ct, { variants: a, content: n }) : null)
), no = t.discriminatedUnion("template", [
  Fe,
  Ye,
  Nt,
  Tt
]), oo = y(
  "ProductAttributes",
  P(no, (a) => a.template === "progress-bar" ? /* @__PURE__ */ e(qn, { ...a }) : a.template === "tags" ? /* @__PURE__ */ e(Jn, { ...a }) : a.template === "icon-blocks" ? /* @__PURE__ */ e(eo, { ...a }) : a.template === "row" ? /* @__PURE__ */ e(ao, { ...a }) : null)
), so = ({ className: a }) => /* @__PURE__ */ p(
  "svg",
  {
    className: a,
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 12 12",
    children: [
      /* @__PURE__ */ e("defs", {}),
      /* @__PURE__ */ e("path", { d: "M0,5h12v2H0v-2Z" })
    ]
  }
), io = ({ className: a }) => /* @__PURE__ */ p(
  "svg",
  {
    className: a,
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 12 12",
    children: [
      /* @__PURE__ */ e("defs", {}),
      /* @__PURE__ */ e("polygon", { points: "12 5 7 5 7 0 5 0 5 5 0 5 0 7 5 7 5 12 7 12 7 7 12 7 12 5" })
    ]
  }
), ro = t.object({
  setDisplayGoToCheckoutButton: t.custom(),
  amount: t.number(),
  slots: t.custom(),
  increaseButtonSettings: ue.optional(),
  decreaseButtonSettings: ue.optional()
}), lo = y(
  "AddToCartQuanityPickerRow",
  P(
    ro,
    ({
      setDisplayGoToCheckoutButton: a,
      slots: o,
      amount: n,
      decreaseButtonSettings: s,
      increaseButtonSettings: i
    }) => {
      const {
        addToCartMethod: c,
        removeFromCartMethod: r,
        quantityInCart: l,
        isAvailable: u
      } = Ie(), h = L();
      function g(v) {
        c.execute(v), a(!0);
      }
      return /* @__PURE__ */ p("div", { className: o.quantityPickerWrapper, children: [
        /* @__PURE__ */ e(
          fe,
          {
            ...s,
            disabled: l < n,
            progress: r.loadingState,
            onClick: () => r.execute(n)
          }
        ),
        /* @__PURE__ */ p("div", { className: o.quantityDisplay, children: [
          /* @__PURE__ */ e("span", { className: o.quantityText, children: n }),
          /* @__PURE__ */ e("span", { className: o.quantityUnit, children: h("PDP_Quantity_Picker_Suffix") })
        ] }),
        /* @__PURE__ */ e(
          fe,
          {
            ...i,
            progress: c.loadingState,
            disabled: !u,
            onClick: () => g(n)
          }
        )
      ] });
    }
  )
), At = t.object({
  template: t.literal("quantity-picker"),
  variants: t.custom().optional(),
  features: t.object({
    increaseButtonSettings: ue.optional(),
    decreaseButtonSettings: ue.optional(),
    itemSuffix: t.string().optional(),
    /** An optional boolean that determines whether the price should be displayed. @default true */
    showPrice: t.boolean().optional(),
    /** An optional array of numbers that defines the quantity options for adding items to the cart @default [1, 10] */
    addQuantityOptions: t.array(t.number()).optional(),
    postAddAction: t.union([t.literal("goToCheckoutButton"), t.literal("none")]).optional()
  }).optional()
}), co = y(
  "AddToCartQuantityPicker",
  P(
    {
      schema: At,
      defaultProps: {
        template: "quantity-picker",
        features: {
          showPrice: !0,
          addQuantityOptions: [1, 10],
          postAddAction: "goToCheckoutButton",
          increaseButtonSettings: {
            variants: {
              width: "auto",
              size: "md",
              color: "primary"
            },
            iconRight: /* @__PURE__ */ e(io, { className: "w-3 h-3" }),
            label: "Add"
          },
          decreaseButtonSettings: {
            variants: {
              width: "same-as-height",
              size: "md",
              color: "white"
            },
            iconLeft: /* @__PURE__ */ e(so, { className: "w-3 h-3" })
          }
        }
      }
    },
    ({ variants: a, features: o }) => {
      var b;
      const n = Pe(), s = ca.styles(a), [i, c] = V(!1), r = L(), [l, u] = V(0);
      Ee(null);
      const {
        addToCartMethod: h,
        removeFromCartMethod: g,
        quantityInCart: v,
        isAvailable: _
      } = Ie(), w = () => {
        l && (l > v ? (h.execute(l - v), c(!0)) : l < v && g.execute(v - l));
      };
      return $(() => {
        u(0);
      }, [v]), /* @__PURE__ */ p("div", { className: s.base, children: [
        /* @__PURE__ */ p("div", { className: s.innerWrapper, children: [
          (o == null ? void 0 : o.showPrice) && /* @__PURE__ */ p(Q, { children: [
            /* @__PURE__ */ e(
              "span",
              {
                className: s.priceTag,
                "data-is-discounted": n.discountInfo ? "true" : "false",
                children: n.price.formatted
              }
            ),
            n.discountInfo && /* @__PURE__ */ e("span", { className: s.oldPriceTag, children: n.priceWithoutDiscount.formatted })
          ] }),
          /* @__PURE__ */ e("div", { className: s.currentQuantityWrapper, children: /* @__PURE__ */ p("div", { className: s.currentQuantityInputWrapper, children: [
            /* @__PURE__ */ e(
              "form",
              {
                onSubmit: (S) => {
                  S.preventDefault(), w();
                },
                children: /* @__PURE__ */ e(
                  "input",
                  {
                    onChange: (S) => {
                      S.preventDefault(), u(parseInt(S.target.value));
                    },
                    value: l > 0 ? l : "",
                    className: s.currentQuantityInput,
                    placeholder: v.toString(),
                    min: "0",
                    type: "number",
                    enterKeyHint: "done",
                    autoComplete: "off",
                    autoCorrect: "off",
                    spellCheck: "false"
                  }
                )
              }
            ),
            l > 0 ? /* @__PURE__ */ e(
              fe,
              {
                disabled: !_,
                onClick: w,
                className: s.updateButton,
                progress: l > v ? h.loadingState : g.loadingState,
                variants: {
                  size: "md",
                  width: "same-as-height"
                },
                label: r("PDP_Quantity_Picker_Update")
              }
            ) : /* @__PURE__ */ e("span", { className: s.currentQuantityUnit, children: r("PDP_Quantity_Picker_Suffix") })
          ] }) }),
          /* @__PURE__ */ e("div", { className: s.quantityPickersWrapper, children: (b = o == null ? void 0 : o.addQuantityOptions) == null ? void 0 : b.map((S, f) => /* @__PURE__ */ e(
            lo,
            {
              increaseButtonSettings: o.increaseButtonSettings,
              decreaseButtonSettings: o.decreaseButtonSettings,
              amount: S,
              slots: s,
              setDisplayGoToCheckoutButton: c
            },
            f
          )) })
        ] }),
        /* @__PURE__ */ e(de, { children: i && /* @__PURE__ */ e(
          J.div,
          {
            initial: { marginTop: -50 },
            animate: { marginTop: 0 },
            transition: {
              type: "spring",
              stiffness: 300,
              damping: 15,
              mass: 0.5
            },
            children: /* @__PURE__ */ e(
              oe,
              {
                as: "a",
                variants: {
                  width: "full",
                  style: "solid",
                  color: "black"
                },
                label: r("PDP_Go_To_Checkout"),
                link: { href: "checkout" }
              }
            )
          }
        ) })
      ] });
    }
  )
), Bt = {
  available: "PDP_Add_To_Cart",
  "out-of-stock": "PDP_Out_Of_Stock",
  discontinued: "PDP_Discontinued",
  "not-determined": "PDP_Select_Size"
}, uo = (a) => {
  const o = De(), n = L(), s = o.status === "out-of-stock" && a ? n("Notify_Me_Submit_Label") : n(Bt[o.status]) ?? "PDP_Select_Size";
  return n(s);
}, Dt = t.object({
  template: t.literal("button"),
  variants: t.custom().optional(),
  buttonSettings: ue.optional(),
  animateAddToCartLabel: t.boolean().optional(),
  postAddAction: t.union([
    t.literal("goToCheckoutButton"),
    t.literal("showMinicart"),
    t.literal("none")
  ]).optional(),
  isNotifyMeEnabled: t.boolean().optional()
}), po = y(
  "AddToCartButton",
  P(
    {
      schema: Dt,
      defaultProps: {
        template: "button",
        animateAddToCartLabel: !0,
        postAddAction: "showMinicart",
        isNotifyMeEnabled: !1
      }
    },
    ({
      variants: a,
      buttonSettings: o,
      animateAddToCartLabel: n,
      postAddAction: s,
      isNotifyMeEnabled: i
    }) => {
      const c = da.styles(a), { addToCartMethod: r, isAvailable: l, isOutOfStock: u, isDiscontinued: h } = Ie(), g = u && i, v = uo(g), _ = L(), w = typeof window < "u" && window.location.pathname.includes("/checkout"), [b, S] = V(!1), f = Ge(async () => {
        if (!h) {
          if (u && i) {
            ce.emit("open", { overlayId: "notify-me" });
            return;
          } else if (!l) {
            Ja.error(_("Add_To_Cart_Error_Not_Available_Toast"));
            return;
          }
          await r.execute(), s === "goToCheckoutButton" && S(!0), s === "showMinicart" && !w && ce.emit("open", { overlayId: "mini-cart" });
        }
      }, [
        u,
        i,
        r,
        s,
        _,
        w
      ]), D = Qt(
        () => n ? /* @__PURE__ */ e(de, { mode: "wait", initial: !1, children: /* @__PURE__ */ e(
          J.span,
          {
            exit: {
              y: "-190%",
              opacity: 0.7,
              transition: {
                duration: 0.15
              }
            },
            initial: {
              y: "150%",
              opacity: 0.7
            },
            animate: {
              y: 0,
              opacity: 1,
              transition: {
                duration: 0.15
              }
            },
            children: v
          },
          v
        ) }) : v,
        [n, v]
      );
      return /* @__PURE__ */ p("div", { className: c.base, id: "add-to-cart-component", children: [
        /* @__PURE__ */ e(
          oe,
          {
            as: "button",
            variants: {
              width: "full"
            },
            ...o,
            progress: r.loadingState,
            dataAttr: {
              "appear-disabled": (u || h) && !g
            },
            "aria-disabled": !l && !g ? "true" : "false",
            label: D,
            onClick: f
          }
        ),
        /* @__PURE__ */ e(de, { initial: !1, children: b && /* @__PURE__ */ e(
          J.div,
          {
            initial: { y: "-100%" },
            animate: { y: 0 },
            transition: {
              duration: 0.5,
              ease: it(0.32, 0.72, 0, 1)
            },
            children: /* @__PURE__ */ e(
              oe,
              {
                as: "a",
                variants: {
                  width: "full",
                  color: "black",
                  style: "outline"
                },
                label: _("PDP_Go_To_Checkout"),
                link: { href: "checkout" }
              }
            )
          }
        ) })
      ] });
    }
  )
), It = t.discriminatedUnion("template", [
  At,
  Dt
]), mo = y(
  "ProductAddToCart",
  P(It, (a) => Z() === "bundle" ? null : a.template === "button" ? /* @__PURE__ */ e(po, { ...a }) : a.template === "quantity-picker" ? /* @__PURE__ */ e(co, { ...a }) : null)
), Se = t.object({
  template: t.literal("button-grid"),
  variants: t.custom().optional(),
  notifyMe: t.object({
    enabled: t.boolean().optional(),
    icon: t.custom().optional()
  }).optional(),
  lowStockIndicator: t.object({
    /**
     * Enables/disables the low stock indicator functionality
     * @default false
     */
    enabled: t.boolean().optional(),
    /**
     * Display a component to indicate low stock
     */
    headerContent: t.custom().optional(),
    /**
     * Threshold value below which stock is considered low
     * Triggers visual indicator when stock drops below this number
     * @default 5
     */
    lowStockLimit: t.number().optional()
  }).optional(),
  headerContent: t.custom().optional()
}), ho = y(
  "SizePickerButtonGrid",
  P(
    Se,
    ({ variants: a, notifyMe: o, lowStockIndicator: n, headerContent: s }) => {
      var w;
      const i = ua.styles(a), { optionGroups: c, selectOption: r, selectedOptions: l } = Me(), u = L(), h = c.length === 1 && ((w = c[0]) == null ? void 0 : w.options.length) === 1;
      if (h)
        return null;
      $(() => {
        var b;
        h && ((b = c[0]) != null && b.options[0]) && r(
          c[0].dimensionKey,
          c[0].options[0]
        );
      }, []);
      const g = (n == null ? void 0 : n.lowStockLimit) ?? 5, v = (b) => (n == null ? void 0 : n.enabled) === !0 && b.inventory.inStock && b.inventory.quantity < g, _ = c.some(
        (b) => b.options.some(v)
      );
      return /* @__PURE__ */ p("div", { className: i.base, children: [
        /* @__PURE__ */ p("div", { className: i.header, children: [
          /* @__PURE__ */ e("span", { children: u("PDP_Size_Picker_Select_Size") }),
          _ ? n == null ? void 0 : n.headerContent : s
        ] }),
        c.map((b) => /* @__PURE__ */ e("div", { className: i.wrapper, children: b.options.map((S) => {
          var A;
          const f = ((A = l[b.dimensionKey]) == null ? void 0 : A.dimensionValue) === S.dimensionValue, D = S.inventory.inStock, C = v(S), x = () => {
            r(b.dimensionKey, S);
          };
          return /* @__PURE__ */ p(
            "button",
            {
              type: "button",
              "data-is-selected": f ? "true" : "false",
              "data-is-out-of-stock": D ? "false" : "true",
              disabled: !D && !(o != null && o.enabled),
              className: i.size,
              "aria-label": S.label,
              onClick: x,
              children: [
                C && (n == null ? void 0 : n.enabled) && /* @__PURE__ */ e("span", { className: i.lowStockIndicator }),
                (o == null ? void 0 : o.enabled) && !D && o.icon,
                S.label
              ]
            },
            S.dimensionValue
          );
        }) }, b.dimensionKey))
      ] });
    }
  )
), bo = {
  direction: "right",
  variants: {
    rounded: "none"
  }
}, go = {
  style: "outline",
  width: "full"
}, ve = t.object({
  template: t.literal("modal"),
  variants: t.custom().optional(),
  drawerSettings: t.custom().optional().describe("Settings for the drawer"),
  buttonVariants: t.custom().optional().describe("Variants for the button"),
  triggerLabel: t.string().optional(),
  sizeButtons: We.optional(),
  aboveButtonComponent: t.custom().optional(),
  belowButtonComponent: t.custom().optional(),
  customOverlayId: t.string().optional()
}), fo = () => {
  const [a, o] = V(
    typeof window < "u" ? window.innerWidth > 1024 : !1
  );
  return $(() => {
    const n = () => {
      o(window.innerWidth > 1024);
    };
    return window.addEventListener("resize", n), () => window.removeEventListener("resize", n);
  }, []), a;
}, vo = y(
  "SizePickerModal",
  P(
    {
      schema: ve,
      defaultProps: {
        template: "modal",
        drawerSettings: bo,
        buttonVariants: go,
        sizeButtons: {
          variants: {
            rounded: "full",
            width: "same-as-height",
            size: "md",
            color: "black",
            style: "outline"
          }
        },
        customOverlayId: "size-picker-modal"
      }
    },
    ({
      variants: a,
      drawerSettings: o,
      buttonVariants: n,
      triggerLabel: s,
      sizeButtons: i,
      aboveButtonComponent: c,
      belowButtonComponent: r,
      customOverlayId: l
    }) => {
      const u = L(), h = fo(), g = pa.styles(a), { optionGroups: v, selectOption: _, selectedOptions: w } = Me();
      return /* @__PURE__ */ p(
        j,
        {
          hasOverlay: !0,
          ...o,
          variants: {
            direction: h ? "right" : "bottom",
            ...(o ?? {}).variants
          },
          customOverlayId: l ?? "size-picker-modal",
          direction: h ? "right" : "bottom",
          children: [
            /* @__PURE__ */ e(j.Trigger, { className: g.trigger, children: /* @__PURE__ */ e(
              rt,
              {
                label: s ?? u("Size_Picker_Select_Size"),
                variants: n
              }
            ) }),
            /* @__PURE__ */ p(j.Content, { children: [
              /* @__PURE__ */ e("div", { className: g.optionsWrapper, children: v.map((b) => /* @__PURE__ */ p(
                "div",
                {
                  className: g.wrapper,
                  "data-dimension-key": b.dimensionKey,
                  "data-dimension-label": b.dimensionLabel,
                  children: [
                    /* @__PURE__ */ e("div", { className: g.header, children: /* @__PURE__ */ e("h3", { className: g.heading, children: u(`Size_Picker_${b.dimensionLabel}`) }) }),
                    /* @__PURE__ */ e("div", { className: g.sizeWrapper, children: b.options.map((S, f) => {
                      var C;
                      const D = ((C = w[b.dimensionKey]) == null ? void 0 : C.dimensionValue) === S.dimensionValue;
                      return /* @__PURE__ */ e(
                        fe,
                        {
                          dataAttr: {
                            "is-selected": D,
                            "is-out-of-stock": !S.inventory.inStock
                          },
                          className: g.size,
                          onClick: () => _(b.dimensionKey, S),
                          label: S.label,
                          ...i
                        },
                        `${S.label}-${f}`
                      );
                    }) })
                  ]
                },
                b.dimensionKey
              )) }),
              c,
              /* @__PURE__ */ e(m.AddToCart, { template: "button" }),
              r
            ] })
          ]
        }
      );
    }
  )
), yo = t.discriminatedUnion("template", [
  Se,
  ve
]), Po = y(
  "ProductSizePicker",
  P(yo, (a) => Z() !== "with_variants" ? null : a.template === "button-grid" ? /* @__PURE__ */ e(ho, { ...a }) : a.template === "modal" ? /* @__PURE__ */ e(vo, { ...a }) : null)
), Xe = t.object({
  template: t.literal("image-card"),
  colorAttributeKey: t.string().optional(),
  maxVisible: t.number().optional(),
  variants: t.custom().optional(),
  headingTag: t.enum(["h1", "h2", "h3", "h4", "h5", "h6"]).optional(),
  hide: t.boolean().optional()
}), So = y(
  "SiblingsImageCard",
  P(
    {
      schema: Xe,
      defaultProps: {
        template: "image-card",
        colorAttributeKey: "product_color",
        headingTag: "h2"
      }
    },
    ({ variants: a, colorAttributeKey: o, headingTag: n, maxVisible: s }) => {
      const i = L(), [c, r] = V(!1), l = ma.styles(a), u = K(
        o ?? "",
        t.string()
      ), h = O(), g = tt(), v = n ?? "h2";
      if (!g.length)
        return null;
      const _ = s !== void 0 && g.length > s ? g.length - s : 0;
      return /* @__PURE__ */ p("div", { className: l.base, children: [
        u && /* @__PURE__ */ e(v, { className: l.header, children: i("PDP_Siblings_Header_Title", {
          color: u.value,
          colorName: u.valueLabel
        }) }),
        /* @__PURE__ */ p("div", { className: l.siblingsWrapper, children: [
          g.map((w, b) => {
            var S, f, D, C, x, A;
            return (D = (f = (S = w.content) == null ? void 0 : S.media) == null ? void 0 : f[0]) != null && D.src ? /* @__PURE__ */ e(
              ye,
              {
                productBase: w,
                context: "product-sibling",
                className: l.sibling,
                "data-is-selected": w.productId === h.productId,
                "data-is-overflow": !c && s !== void 0 && b >= s,
                children: /* @__PURE__ */ e(
                  te,
                  {
                    image: { src: (A = (x = (C = w.content) == null ? void 0 : C.media) == null ? void 0 : x[0]) == null ? void 0 : A.src },
                    displaySize: {
                      mobile: "80px",
                      tablet: "80px",
                      desktop: "80px"
                    },
                    className: l.siblingImage
                  }
                )
              },
              b
            ) : null;
          }),
          _ > 0 && /* @__PURE__ */ e(
            "button",
            {
              type: "button",
              onClick: () => r((w) => !w),
              className: l.overflowToggle,
              children: c ? i("PDP_Siblings_Show_Less") : i("PDP_Siblings_Show_More", {
                count: _
              })
            }
          )
        ] })
      ] });
    }
  )
), wo = (a) => /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(a), _o = (a) => /^[a-zA-Z]+$/.test(a) || /^[a-zA-Z]+\s[a-zA-Z]+$/.test(a), ko = (a) => /^rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)$/.test(a) || /^rgba\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*,\s*[\d.]+\s*\)$/.test(a), No = (a) => a.startsWith("http") || a.startsWith("/") || /\.(png|jpe?g|gif|svg|webp)$/i.test(a), Lt = ({
  sibling: a,
  colorSwatchAttributeKey: o,
  className: n
}) => {
  const s = O(), i = ee(a);
  if (!o)
    return null;
  const c = i(
    o,
    t.string()
  );
  if (!(c != null && c.valueLabel))
    return null;
  const r = c.valueLabel, l = c.value, u = () => l ? No(l) ? {
    backgroundImage: `url(${l})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat"
  } : wo(l) || _o(l) || ko(l) ? { backgroundColor: l } : { backgroundColor: "#cccccc" } : {}, h = `${r || ""} color option`;
  return /* @__PURE__ */ e(
    ye,
    {
      productBase: a,
      context: "product-sibling",
      className: n,
      style: u(),
      "data-is-selected": s.productId === a.productId,
      "data-is-white": l === "#ffffff" || (r == null ? void 0 : r.toLocaleLowerCase()) === "white" || (r == null ? void 0 : r.toLocaleLowerCase()) === "vit",
      "aria-label": h,
      title: r || "",
      role: "button",
      "data-testid": `color-swatch-${r == null ? void 0 : r.toLowerCase().replace(/\s+/g, "-")}`
    },
    a.productKey
  );
}, zt = t.object({
  template: t.literal("color-swatch"),
  colorSwatchAttributeKey: t.string().optional(),
  variants: t.custom().optional(),
  hide: t.boolean().optional()
}), To = y(
  "SiblingColorSwatchList",
  P(
    {
      schema: zt,
      defaultProps: {
        template: "color-swatch",
        colorSwatchAttributeKey: "product_color"
      }
    },
    ({ variants: a, colorSwatchAttributeKey: o }) => {
      const n = ha.styles(a), s = O(), i = L(), c = tt(), r = ee(s);
      if (!o || !c.length)
        return null;
      const l = r(
        o,
        t.string()
      );
      return l ? /* @__PURE__ */ p("div", { className: n.base, children: [
        /* @__PURE__ */ e("div", { className: n.header, children: i("PDP_Product_ColorSwatch_Label", {
          color: l.valueLabel
        }) }),
        /* @__PURE__ */ e("div", { className: n.siblingsWrapper, children: c.map((u, h) => /* @__PURE__ */ e(
          Lt,
          {
            sibling: u,
            colorSwatchAttributeKey: o,
            className: n.sibling
          },
          `sibling.productKey-${h}`
        )) })
      ] }) : null;
    }
  )
), we = t.discriminatedUnion("template", [
  Xe,
  zt
]), Co = y(
  "ProductSiblings",
  P(we, (a) => a.hide === !0 ? null : a.template === "image-card" ? /* @__PURE__ */ e(So, { ...a }) : a.template === "color-swatch" ? /* @__PURE__ */ e(To, { ...a }) : null)
), xt = t.object({
  template: t.literal("image-cards"),
  swiperSettings: ct.optional(),
  relationType: t.string().optional(),
  productCardSettings: en.optional()
}), Ao = (a) => {
  const o = an(), n = L();
  if (!o || o.length === 0)
    return null;
  const s = ba.styles();
  return /* @__PURE__ */ p("div", { className: s.base, children: [
    /* @__PURE__ */ e("h3", { className: s.heading, children: n("PDP_Related_Products_Image_Cards_Heading") }),
    /* @__PURE__ */ e("div", { className: s.wrapper, children: o.slice(0, 3).map((i, c) => i.type !== "product" ? null : /* @__PURE__ */ e(
      je,
      {
        product: i.product,
        context: {
          type: "plp",
          listId: "related-products",
          listName: "Related Products",
          position: c
        },
        children: /* @__PURE__ */ e(tn, { templateProps: a.productCardSettings })
      },
      c
    )) })
  ] });
}, Rt = y(
  "ProductRelatedProductsImageCards",
  P(xt, ({ relationType: a, ...o }) => {
    const n = Be(a);
    if (!Rt.length)
      return null;
    const s = {
      items: n.map((i) => ({ type: "product", product: i.product })),
      meta: {
        currentPage: 1,
        totalPages: 5,
        itemsPerPage: 12,
        totalItems: n.length
      },
      facets: [],
      sort: []
    };
    return /* @__PURE__ */ e(lt, { result: s, children: /* @__PURE__ */ e(Ao, { ...o }) });
  })
), Et = t.object({
  template: t.literal("swiper"),
  swiperSettings: ct.optional(),
  relationType: t.string().optional()
}), Bo = y(
  "ProductRelatedProductsSwiper",
  P(Et, ({ swiperSettings: a, relationType: o }) => {
    const n = Be(o);
    if (!n.length)
      return null;
    const s = {
      items: n.map((i) => ({ type: "product", product: i.product })),
      meta: {
        currentPage: 1,
        totalPages: 5,
        itemsPerPage: 12,
        totalItems: n.length
      },
      sort: [],
      facets: []
    };
    return /* @__PURE__ */ e(lt, { result: s, children: /* @__PURE__ */ e(nn, { ...a }) });
  })
), ie = t.discriminatedUnion("template", [
  xt,
  Et
]), Do = y(
  "RelatedProducts",
  P(ie, (a) => a.template === "image-cards" ? /* @__PURE__ */ e(Rt, { ...a }) : a.template === "swiper" ? /* @__PURE__ */ e(Bo, { ...a }) : null)
), Io = ({
  targetSelector: a,
  mode: o = "isNotVisible"
}) => {
  const [n, s] = V(!1), i = Ee(null), c = Ee(null);
  $(() => {
    if (o === "isAlwaysVisible") {
      s(!0);
      return;
    } else if (o === "isAlwaysHidden") {
      s(!1);
      return;
    }
  }, [o]);
  const r = Ge(() => {
    if (!i.current)
      return;
    const u = i.current.getBoundingClientRect();
    switch (o) {
      case "isScrolledPast":
        s(u.bottom <= 0);
        break;
      case "isBeforeView":
        s(u.top >= window.innerHeight);
        break;
    }
  }, [o]), l = Ge(() => {
    c.current && cancelAnimationFrame(c.current), c.current = requestAnimationFrame(() => {
      r(), c.current = null;
    });
  }, [r]);
  return $(() => {
    if (o === "isAlwaysVisible" || o === "isAlwaysHidden" || (i.current = document.querySelector(a), !i.current))
      return;
    let u = null;
    return o === "isVisible" || o === "isNotVisible" ? (u = new IntersectionObserver(
      ([h]) => {
        h && s(
          o === "isVisible" ? h.isIntersecting : !h.isIntersecting
        );
      },
      { threshold: 0.1 }
    ), u.observe(i.current)) : (r(), window.addEventListener("scroll", l, { passive: !0 }), window.addEventListener("resize", l, { passive: !0 })), () => {
      u ? u.disconnect() : (window.removeEventListener("scroll", l), window.removeEventListener("resize", l)), c.current && cancelAnimationFrame(c.current);
    };
  }, [a, o, r, l]), n;
}, Gt = t.object({
  template: t.literal("button"),
  variants: t.custom().optional(),
  buttonSettings: ue.optional(),
  mode: t.custom().optional(),
  targetSelector: t.string().optional(),
  selectSizeAction: t.union([t.literal("open-size-picker"), t.literal("scroll-to-size-picker")]).optional(),
  withSizePicker: t.boolean().optional(),
  sizePickerOverlayId: t.string().optional(),
  showPrice: t.boolean().optional()
}), Lo = y(
  "StickyAddToCartButton",
  P(
    {
      schema: Gt,
      defaultProps: {
        template: "button",
        mode: "isScrolledPast",
        targetSelector: "#add-to-cart-component",
        selectSizeAction: "scroll-to-size-picker",
        withSizePicker: !1,
        sizePickerOverlayId: "size-picker-modal",
        showPrice: !0
      }
    },
    ({
      variants: a,
      buttonSettings: o,
      mode: n,
      targetSelector: s,
      selectSizeAction: i,
      withSizePicker: c,
      sizePickerOverlayId: r,
      showPrice: l
    }) => {
      const u = ga.styles(a), { addToCartMethod: h, isAvailable: g } = Ie(), v = De(), _ = L(), { selectedOptions: w } = Me(), b = Object.values(w).filter((A) => !!A).map((A) => A.label).join(" / "), S = Pe(), f = Io({
        targetSelector: s ?? "#add-to-cart-component",
        mode: n
      }), D = typeof window < "u" && window.location.pathname.includes("/checkout"), C = () => {
        ce.emit("open", {
          overlayId: r ?? "size-picker-modal"
        });
      }, x = async () => {
        if (!g) {
          if (i === "open-size-picker") {
            C();
            return;
          }
          if (i === "scroll-to-size-picker") {
            const A = document.getElementById("add-to-cart-component");
            A == null || A.scrollIntoView({
              behavior: "smooth",
              block: "end"
            });
            return;
          }
        }
        await h.execute(), D || ce.emit("open", { overlayId: "mini-cart" });
      };
      return v.status === "out-of-stock" ? null : c ? /* @__PURE__ */ e(
        "div",
        {
          className: u.base,
          "data-is-visible": f ? "true" : "false",
          children: /* @__PURE__ */ p("div", { className: u.buttonsWrapper, children: [
            /* @__PURE__ */ e(
              oe,
              {
                as: "button",
                variants: {
                  width: "full",
                  style: "outline",
                  color: "black"
                },
                label: g ? b : _("PDP_Select_Size"),
                onClick: C
              }
            ),
            /* @__PURE__ */ e(
              oe,
              {
                as: "button",
                variants: {
                  width: "full"
                },
                ...o,
                progress: h.loadingState,
                label: /* @__PURE__ */ p(Q, { children: [
                  _("PDP_Add_To_Cart"),
                  l && /* @__PURE__ */ p(Q, { children: [
                    " ",
                    /* @__PURE__ */ e("span", { children: S.price.formatted })
                  ] })
                ] }),
                onClick: x
              }
            )
          ] })
        }
      ) : /* @__PURE__ */ e(
        "div",
        {
          className: u.base,
          "data-is-visible": f ? "true" : "false",
          children: /* @__PURE__ */ e(
            oe,
            {
              as: "button",
              variants: {
                width: "full",
                justifyContent: "between"
              },
              ...o,
              progress: h.loadingState,
              label: /* @__PURE__ */ p(Q, { children: [
                _(g ? "PDP_Add_To_Cart" : "PDP_Select_Size"),
                l && /* @__PURE__ */ p(Q, { children: [
                  " ",
                  /* @__PURE__ */ e("span", { children: S.price.formatted })
                ] })
              ] }),
              onClick: x
            }
          )
        }
      );
    }
  )
), zo = t.discriminatedUnion("template", [
  Gt
]), xo = y(
  "ProductStickyAddToCart",
  P(zo, (a) => Z() !== "with_variants" ? null : a.template === "button" ? /* @__PURE__ */ e(Lo, { ...a }) : null)
), Ro = () => Z() !== "bundle" ? null : /* @__PURE__ */ e(Eo, {}), Eo = () => {
  const { sections: a } = He(), o = Ce.styles();
  return /* @__PURE__ */ p("div", { className: o.base, children: [
    /* @__PURE__ */ e("div", { className: o.sectionsWrapper, children: Object.values(a).map((n, s) => /* @__PURE__ */ e(
      je,
      {
        product: n.activeProduct.product,
        context: {
          type: "plp",
          listId: "bundle-section",
          listName: "Bundle Section",
          position: s
        },
        children: /* @__PURE__ */ e(Go, { section: n, index: s })
      },
      s
    )) }),
    /* @__PURE__ */ e(jo, {}),
    /* @__PURE__ */ e(Mo, {})
  ] });
}, Go = ({
  section: a,
  index: o
}) => {
  const n = O(), { selectSectionProduct: s } = He(), i = Ce.styles(), c = L(), r = (l) => {
    s(a.sectionId, l);
  };
  return /* @__PURE__ */ p("div", { className: i.section, children: [
    /* @__PURE__ */ e(de, { mode: "wait", initial: !1, children: /* @__PURE__ */ e("div", { className: i.productNameWrapper, children: /* @__PURE__ */ e(
      J.h3,
      {
        className: i.productName,
        exit: {
          y: "-100%"
        },
        initial: {
          y: "100%"
        },
        animate: {
          y: 0
        },
        transition: {
          duration: 0.35,
          ease: it(0.32, 0.72, 0, 1)
        },
        children: c("PDP_Bundle_Selection_Product", {
          index: o + 1,
          product: n.content.name
        })
      }
    ) }, n.content.name) }),
    /* @__PURE__ */ e("h3", { className: i.selectionHeading, children: c("PDP_Bundle_Selection_Heading") }),
    /* @__PURE__ */ e("div", { className: i.productSlider, children: a.products.map((l, u) => {
      const h = l.base.productId === a.activeProduct.product.base.productId;
      return /* @__PURE__ */ e(
        Wo,
        {
          product: l,
          isSelected: h,
          onClick: () => r(l)
        },
        u
      );
    }) }),
    /* @__PURE__ */ e(Oo, { sectionId: a.sectionId }),
    /* @__PURE__ */ e(
      Xa,
      {
        link: { href: a.activeProduct.product.base.slug },
        label: c("PDP_Bundle_Selection_Link"),
        className: i.link
      }
    )
  ] });
}, Wo = ({
  product: a,
  isSelected: o,
  onClick: n
}) => {
  var l;
  const s = Ce.styles(), i = (l = a.base.content.media) == null ? void 0 : l[0], r = ee(a.base)("product_color", t.string());
  return /* @__PURE__ */ p(
    "button",
    {
      className: s.productWrapper,
      onClick: n,
      "data-is-selected": o ? "true" : "false",
      children: [
        i && /* @__PURE__ */ e(te, { className: s.productImage, image: i }),
        r && /* @__PURE__ */ p("div", { className: s.swatchWrapper, children: [
          /* @__PURE__ */ e(
            Lt,
            {
              sibling: a.base,
              colorSwatchAttributeKey: "colorSwatch",
              className: s.swatch
            }
          ),
          /* @__PURE__ */ e("span", { className: s.swatchLabel, children: r == null ? void 0 : r.valueLabel })
        ] })
      ]
    }
  );
}, Oo = ({ sectionId: a }) => {
  const o = Z(), n = De(), { selectSectionSize: s } = He(), i = L(), c = n.status === "available" ? n.availableItemId : void 0;
  switch ($(() => {
    s(a, c);
  }, [c]), o) {
    case "with_variants":
      return /* @__PURE__ */ e(m.SizePicker, { template: "button-grid" });
    case "simple":
      return /* @__PURE__ */ e(
        "button",
        {
          "data-is-selected": n.status === "out-of-stock" ? "false" : "true",
          "data-is-out-of-stock": n.status === "out-of-stock" ? "true" : "false",
          className: "w-1/2 h-10 text-label-sm uppercase font-medium bg-transparent rounded-md border data-[is-out-of-stock=true]:text-less-emphasis-3 data-[is-selected=true]:text-white data-[is-selected=true]:bg-black relative data-[is-out-of-stock=true]:before:absolute data-[is-out-of-stock=true]:before:w-[1px] data-[is-out-of-stock=true]:before:h-[140%] data-[is-out-of-stock=true]:before:bg-less-emphasis-3 data-[is-out-of-stock=true]:before:top-[-20%] before:left-1/2 before:-translate-x-1/2 before:rotate-45 [&>svg]:w-5 [&>svg]:h-5",
          children: i("PDP_Size_Picker_One_Size")
        }
      );
    default:
      return null;
  }
}, jo = () => {
  const a = Ae(), o = Ce.styles(), n = L();
  return /* @__PURE__ */ p("div", { className: o.totalsWrapper, children: [
    /* @__PURE__ */ p("div", { className: o.totalsRow, children: [
      /* @__PURE__ */ e("span", { className: o.totalsLabel, children: n("PDP_Bundle_Discount_Label") }),
      /* @__PURE__ */ p("span", { className: o.totalsValue, children: [
        "-",
        a.discountFromPriceOfItemsOutsideBundle.formatted
      ] })
    ] }),
    /* @__PURE__ */ p("div", { className: o.totalsRow, children: [
      /* @__PURE__ */ e("span", { className: o.totalsLabel, children: n("PDP_Bundle_Price_Label") }),
      /* @__PURE__ */ e("span", { className: o.totalsValue, children: a.priceInfo.price.formatted })
    ] })
  ] });
}, Mo = () => {
  const a = za(), o = xa(), { execute: n } = Ka("addBundleToCart"), [s, i] = W.useState("default"), c = L(), r = async () => {
    if (o.status === "available")
      try {
        i("loading"), await n({
          itemId: a,
          sections: o.sections.map((u) => ({
            sectionId: u.sectionId,
            itemId: u.availableItemId
          }))
        }), await new Promise((u) => setTimeout(u, 1e3)), i("complete"), await new Promise((u) => setTimeout(u, 1e3));
      } catch {
        i("default"), await new Promise((h) => setTimeout(h, 1e3));
      } finally {
        i("default"), ce.emit("open", { overlayId: "mini-cart" });
      }
  }, l = o.status === "available";
  return /* @__PURE__ */ e(
    oe,
    {
      as: "button",
      variants: {
        width: "full"
      },
      progress: s,
      "aria-disabled": l ? "false" : "true",
      label: c(Bt[o.status]),
      onClick: r
    }
  );
}, me = t.object({
  items: t.array(
    t.object({
      label: t.string().optional(),
      icon: t.custom().optional()
    })
  ).optional(),
  attributeKey: t.string().optional(),
  variants: t.custom().optional()
}), Ho = y(
  "ProductUspBlock",
  P(
    {
      schema: me,
      defaultProps: {
        attributeKey: "usps"
      }
    },
    ({ items: a, variants: o, attributeKey: n }) => {
      var c, r;
      const s = fa.styles(o), i = (c = K(
        n ?? "usps",
        t.array(
          t.object({
            label: t.string(),
            icon: t.string().optional()
          })
        )
      )) == null ? void 0 : c.value;
      return !a && !i ? null : /* @__PURE__ */ e("div", { className: s.base, children: (r = a ?? i) == null ? void 0 : r.map((l, u) => /* @__PURE__ */ p("div", { className: s.item, children: [
        l.icon,
        /* @__PURE__ */ e("span", { className: s.label, children: l.label })
      ] }, u)) });
    }
  )
), Wt = t.object({
  template: t.literal("scale"),
  variants: t.custom().optional(),
  /**
   * On a scale of. @default 10
   * @type {number}
   *  */
  onAScaleOf: t.number().optional()
}), Ko = y(
  "ProductSizeRecommendationScale",
  P(
    {
      schema: Wt,
      defaultProps: {
        template: "scale",
        onAScaleOf: 10
      }
    },
    ({ onAScaleOf: a }) => {
      O();
      const o = va.styles(), n = L(), s = K(
        "sizeRecommendation",
        t.string()
      ), i = K(
        "sizeRecommendationScale",
        t.string()
      );
      if (!(!(i != null && i.value) || !(s != null && s.value)))
        return /* @__PURE__ */ p("div", { className: o.base, children: [
          (i == null ? void 0 : i.value) && i.value && /* @__PURE__ */ p(Q, { children: [
            /* @__PURE__ */ e("h3", { className: o.label, children: n("PDP_Size_Recommendation_Scale_Label") }),
            /* @__PURE__ */ e("div", { className: o.bar, children: /* @__PURE__ */ e(
              J.div,
              {
                className: o.dot,
                initial: {
                  left: `${parseInt(i.value) / (a ?? 10) * 100}%`,
                  scale: 0
                },
                whileInView: {
                  scale: 1
                },
                transition: {
                  delay: 0.25
                },
                exit: { scale: 0 }
              }
            ) }),
            /* @__PURE__ */ p("div", { className: o.scaleLabels, children: [
              /* @__PURE__ */ e("span", { className: o.scaleLabel, children: n("PDP_Size_Recommendation_Scale_Small") }),
              /* @__PURE__ */ e("span", { className: o.scaleLabel, children: n("PDP_Size_Recommendation_Scale_Perfect") }),
              /* @__PURE__ */ e("span", { className: o.scaleLabel, children: n("PDP_Size_Recommendation_Scale_Big") })
            ] })
          ] }),
          (s == null ? void 0 : s.value) && /* @__PURE__ */ e("span", { className: o.sizeText, children: s.value })
        ] });
    }
  )
), Vo = t.discriminatedUnion("template", [
  Wt
]), Uo = y(
  "SizeRecommendation",
  P(Vo, (a) => {
    if (a.template === "scale")
      return /* @__PURE__ */ e(Ko, { ...a });
  })
), $o = t.object({
  variants: t.custom().optional(),
  template: t.enum(["button", "text"]).optional(),
  buttonVariants: qa.shape.variants.optional()
}), Fo = y(
  "ProductBundleUpsell",
  P(
    {
      schema: $o,
      defaultProps: {
        template: "button",
        buttonVariants: {
          width: "full",
          color: "black",
          style: "outline"
        }
      }
    },
    ({ variants: a, buttonVariants: o, template: n }) => {
      const s = Be("bundle")[0], i = L(), c = ya.styles(a);
      return s ? /* @__PURE__ */ e(
        ye,
        {
          productBase: s.product.base,
          className: c.base,
          children: n === "button" ? /* @__PURE__ */ e(
            rt,
            {
              label: i("PDP_Bundle_Upsell_Title", {
                // Add support for discount when it exists.
                name: s.product.base.content.name
              }),
              variants: o
            }
          ) : /* @__PURE__ */ e("span", { children: i("PDP_Bundle_Upsell_Title", {
            name: s.product.base.content.name
          }) })
        }
      ) : null;
    }
  )
), Ot = t.object({
  heading: t.string().optional(),
  subtitle: t.string().optional(),
  image: at.optional().nullable(),
  condition: t.string().optional(),
  variants: t.custom().optional()
}), Yo = y(
  "ProductGiftWithPurchase",
  P(
    {
      schema: Ot,
      defaultProps: {
        image: {
          displaySize: "5vw"
        }
      }
    },
    ({ heading: a, subtitle: o, image: n, variants: s, condition: i }) => {
      var r;
      const c = Pa.styles(s);
      return !a && !o && !(n != null && n.image) ? null : /* @__PURE__ */ p("div", { className: c.base, children: [
        /* @__PURE__ */ p("div", { className: c.contentWrapper, children: [
          n && ((r = n.image) == null ? void 0 : r.src) && /* @__PURE__ */ e(te, { ...n, className: c.image }),
          /* @__PURE__ */ p("div", { className: c.textWrapper, children: [
            a && /* @__PURE__ */ e("h3", { className: c.heading, children: a }),
            o && /* @__PURE__ */ e(on, { content: o, className: c.subtitle })
          ] })
        ] }),
        i && /* @__PURE__ */ e("span", { className: c.condition, children: i })
      ] });
    }
  )
), jt = t.object({
  template: t.literal("cairo"),
  variants: t.custom().optional(),
  content: t.custom()
}), Xo = y(
  "SizeGuideContent",
  P(jt, ({ variants: a, content: o }) => {
    const n = Sa.styles(a);
    return /* @__PURE__ */ e(sn.Provider, { value: !0, children: /* @__PURE__ */ e("div", { className: n.contentWrapper, children: o }) });
  })
), Mt = t.object({
  template: t.literal("drawer"),
  contentSettings: jt.optional(),
  drawerSettings: t.custom().optional(),
  enabled: t.boolean().optional(),
  applyButtonSettings: We.optional(),
  closeButtonSettings: We.optional()
}), Qo = "cairo", Zo = 1024, qo = y(
  "SizeGuideDrawer",
  P(Mt, (a) => {
    wa.styles(), L();
    const o = a.contentSettings || {
      template: Qo
    };
    if (!a.enabled)
      return null;
    const [n, s] = V(!1);
    return $(() => {
      const i = () => {
        s(window.innerWidth > Zo);
      };
      return window.addEventListener("resize", i), i(), () => {
        window.removeEventListener("resize", i);
      };
    }, []), /* @__PURE__ */ e(
      j,
      {
        customOverlayId: "size-guide",
        hasOverlay: !0,
        hasScaledBackground: !0,
        setBackgroundColorOnScale: !1,
        hasHandle: !n,
        variants: {
          dragHandle: n ? "false" : "true",
          rounded: n ? "none" : "strong",
          background: "white",
          direction: n ? "right" : "bottom"
        },
        direction: n ? "right" : "bottom",
        ...a.drawerSettings,
        children: /* @__PURE__ */ e(j.Content, { children: /* @__PURE__ */ e(Xo, { ...o }) })
      }
    );
  })
), ze = t.discriminatedUnion("template", [
  Mt
]), Jo = y(
  "SizeGuide",
  P(ze, (a) => {
    switch (a.template) {
      case "drawer":
        return /* @__PURE__ */ e(qo, { ...a });
      default:
        return null;
    }
  })
), xe = t.object({
  link: Qa.optional(),
  label: t.string().optional(),
  icon: t.custom().optional(),
  variants: t.custom().optional()
}), es = y(
  "SizeGuideTrigger",
  P(xe, ({ variants: a, label: o, link: n, icon: s }) => {
    const i = _a.styles(a);
    return /* @__PURE__ */ e(
      Za,
      {
        onClick: () => ce.emit("open", { overlayId: "size-guide" }),
        className: i.trigger,
        label: o,
        icon: s,
        ...n
      }
    );
  })
), ts = t.object({
  variants: t.custom().optional()
}), as = ({ variants: a }) => {
  const o = L(), n = ka.styles(a), s = Ae(), i = s.discountFromPriceOfItemsOutsideBundle.formatted, c = s.discountFromPriceOfItemsOutsideBundle.number;
  return !i || c <= 0 ? null : /* @__PURE__ */ p("div", { className: n.base, children: [
    /* @__PURE__ */ e("h3", { className: n.heading, children: o("PDP_Bundle_Promo_Banner_Heading", {
      bundleSavings: i
    }) }),
    /* @__PURE__ */ e("p", { className: n.text, children: o("PDP_Bundle_Promo_Banner_Text") })
  ] });
}, ns = y(
  "ProductBundlePromoBanner",
  P(
    {
      schema: ts,
      defaultProps: {}
    },
    (a) => Z() !== "bundle" ? null : /* @__PURE__ */ e(as, { ...a })
  )
), m = {
  SizeGuide: Jo,
  Details: zn,
  Root: fn,
  ImageGallery: Yn,
  AddToCart: mo,
  Specifications: Qn,
  Attributes: oo,
  SizePicker: Po,
  Siblings: Co,
  RelatedProducts: Do,
  StickyAddToCart: xo,
  Bundle: Ro,
  BundleUpsell: Fo,
  UspBlock: Ho,
  SizeGuideTrigger: es,
  SizeRecommendation: Uo,
  GiftWithPurchase: Yo,
  BundlePromoBanner: ns,
  PriceHistoryDrawer: Nn
  // Add other components as needed
}, Ht = t.object({
  template: t.literal("basic"),
  variants: t.custom().optional(),
  productTypeSettings: pe.optional(),
  productDesignerSettings: pe.optional(),
  relatedProductsSettings: ie.optional(),
  sizePickerSettings: Se.optional(),
  uspBlockSettings: me.optional(),
  siblingsPickerSettings: we.optional(),
  sizeGuideSettings: ze.optional(),
  sizeGuideTriggerSettings: xe.optional(),
  belowTheFoldComponents: t.custom().optional()
}), os = y(
  "ProductTemplateAsBasic",
  P(
    {
      schema: Ht,
      defaultProps: {
        template: "basic",
        relatedProductsSettings: {
          template: "swiper",
          swiperSettings: {
            settings: {
              template: "template1",
              itemsInView: {
                initial: "2.1",
                lg: "4",
                xl: "4"
              },
              spacing: {
                y: {
                  initial: "lg",
                  lg: "md",
                  xl: "md"
                }
              },
              variants: {
                background: { initial: "none", lg: "white" }
              }
            }
          }
        }
      }
    },
    ({
      relatedProductsSettings: a,
      sizePickerSettings: o,
      uspBlockSettings: n,
      siblingsPickerSettings: s,
      sizeGuideSettings: i,
      sizeGuideTriggerSettings: c,
      belowTheFoldComponents: r
    }) => {
      var g;
      const l = O(), u = Na.styles(), h = L();
      return /* @__PURE__ */ e(de, { mode: "wait", children: /* @__PURE__ */ p(
        J.section,
        {
          initial: { opacity: 0 },
          animate: { opacity: 1 },
          exit: { opacity: 0 },
          id: l.productId,
          className: u.base,
          children: [
            /* @__PURE__ */ e(
              se,
              {
                variants: { isOn: "pdp" },
                enableWrapper: !1,
                className: "block lg:hidden ml-3 mb-3"
              }
            ),
            /* @__PURE__ */ e(m.ImageGallery, { template: "keen", indicator: "number" }),
            /* @__PURE__ */ e(m.ImageGallery, { template: "grid" }),
            /* @__PURE__ */ p("section", { className: u.detailsWrapper, children: [
              /* @__PURE__ */ e(
                se,
                {
                  variants: { isOn: "pdp" },
                  enableWrapper: !1,
                  className: "hidden lg:block mb-4"
                }
              ),
              /* @__PURE__ */ e(m.Details.Brand, {}),
              /* @__PURE__ */ e(m.Details.Name, {}),
              /* @__PURE__ */ e(m.Details.Price, {}),
              /* @__PURE__ */ e(m.Attributes, { template: "tags", attributeKey: "sticker" }),
              /* @__PURE__ */ e(
                m.Siblings,
                {
                  template: "image-card",
                  ...s
                }
              ),
              /* @__PURE__ */ e(m.SizeGuide, { template: "drawer", ...i }),
              /* @__PURE__ */ e(
                m.SizePicker,
                {
                  template: "button-grid",
                  ...o,
                  headerContent: /* @__PURE__ */ e(
                    m.SizeGuideTrigger,
                    {
                      ...c,
                      label: h("Size_Guide_Trigger_Label")
                    }
                  )
                }
              ),
              /* @__PURE__ */ e(m.AddToCart, { template: "button" }),
              /* @__PURE__ */ e(m.UspBlock, { ...n }),
              /* @__PURE__ */ e(
                m.Attributes,
                {
                  label: h("PDP_Product_Features_Label"),
                  template: "icon-blocks",
                  attributeKey: "productFeatures"
                }
              )
            ] }),
            /* @__PURE__ */ p("div", { className: u.belowTheFoldDetails, children: [
              /* @__PURE__ */ e(
                m.Details.Description,
                {
                  label: h("PDP_Product_Description_Label")
                }
              ),
              /* @__PURE__ */ e(
                m.Details.Accordion,
                {
                  settings: {
                    radixAccordionSettings: {
                      root: {
                        type: "single",
                        collapsible: !0,
                        defaultValue: "details"
                      }
                    }
                  },
                  items: [
                    {
                      content: {
                        trigger: h("PDP_Product_Details"),
                        value: "details",
                        content: l.content.description
                      }
                    },
                    {
                      content: {
                        trigger: h("PDP_Fabric_Care"),
                        attributeKey: "fabricCare_text"
                      }
                    },
                    {
                      content: {
                        trigger: h("PDP_Product_Material"),
                        attributeKey: "material"
                      }
                    },
                    {
                      content: {
                        trigger: h("PDP_Product_Manufacturer"),
                        attributeKey: "supplier"
                      }
                    },
                    {
                      content: {
                        trigger: h("PDP_Product_CareGuide"),
                        attributeKey: "care_guide"
                      }
                    },
                    {
                      content: {
                        trigger: h("PDP_Product_Manufacturer"),
                        attributeKey: "manufacturer"
                      }
                    },
                    {
                      content: {
                        trigger: h("PDP_Product_Shipping"),
                        attributeKey: "shipping"
                      }
                    }
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ e("div", { className: u.relatedProductsWrapper, children: /* @__PURE__ */ e(
              m.RelatedProducts,
              {
                template: "swiper",
                swiperSettings: {
                  settings: {
                    template: "template1",
                    ...(g = a == null ? void 0 : a.swiperSettings) == null ? void 0 : g.settings,
                    headerSettings: {
                      heading: {
                        heading: h("PDP_Related_Products_Header")
                      }
                    }
                  }
                }
              }
            ) }),
            r
          ]
        }
      ) });
    }
  )
), Kt = t.object({
  template: t.literal("helsinki"),
  breadcrumbsSettings: rn.optional(),
  imageGallerySettings: wt.optional(),
  addToCartSettings: It.optional(),
  descriptionSettings: Ve.optional(),
  specificationSettings: kt.optional(),
  progressBarSettings: Fe.optional(),
  tagsSettings: t.array(Ye).optional(),
  relatedProductsSettings: ie.optional(),
  discontinuedBadgeWrapper: st.optional(),
  shippingBarometer: ln.optional(),
  id: t.string().optional()
}), ss = y(
  "ProductPageTemplateHelsinki",
  P(
    {
      schema: Kt,
      defaultProps: {
        template: "helsinki",
        breadcrumbsSettings: {
          variants: {
            isOn: "pdp"
          }
        },
        discontinuedBadgeWrapper: {
          rotate: "randomize"
          // variants: {
          //   color: "red",
          // },
        },
        imageGallerySettings: {
          template: "keen",
          indicator: "dots"
        },
        addToCartSettings: {
          template: "quantity-picker"
        },
        descriptionSettings: {
          readMoreSettings: {
            enabled: !0,
            limit: 160
          }
        },
        specificationSettings: {
          template: "table"
        },
        relatedProductsSettings: {
          template: "swiper",
          swiperSettings: {
            settings: {
              template: "template1",
              itemsInView: {
                initial: "2.1",
                lg: "4",
                xl: "4"
              },
              spacing: {
                y: {
                  initial: "lg",
                  lg: "md",
                  xl: "md"
                }
              },
              variants: {
                background: { initial: "none", lg: "white" }
              }
            }
          }
        }
      }
    },
    ({
      breadcrumbsSettings: a,
      imageGallerySettings: o,
      addToCartSettings: n,
      descriptionSettings: s,
      specificationSettings: i,
      progressBarSettings: c,
      tagsSettings: r,
      relatedProductsSettings: l,
      discontinuedBadgeWrapper: u,
      shippingBarometer: h,
      id: g
    }) => {
      var b;
      const { status: v } = De(), _ = L(), w = Ta.styles();
      return /* @__PURE__ */ p(
        "section",
        {
          id: g,
          className: "grid-cols-12 lg:grid-rows-[min-content_max-content] grid lg:gap-4 w-full lg:gap-y-12 bg-white lg:px-8 rounded-lg lg:max-h-[90vh] overflow-y-scroll",
          children: [
            /* @__PURE__ */ p(m.ImageGallery, { ...o, template: "keen", children: [
              /* @__PURE__ */ e(
                se,
                {
                  ...a,
                  layout: {
                    spacing: { applySpacing: "false" },
                    position: { applyPosition: "false" }
                  }
                }
              ),
              v === "discontinued" && /* @__PURE__ */ e("div", { className: w.discountinuedBadgeWrapper, children: /* @__PURE__ */ e(
                Ke,
                {
                  label: _("PDP_Discontinued_Badge"),
                  ...u
                }
              ) })
            ] }),
            /* @__PURE__ */ p("div", { className: w.addToCartWrapper, children: [
              /* @__PURE__ */ e(m.Details.Name, {}),
              v === "out-of-stock" && /* @__PURE__ */ p("div", { className: w.outOfStock, children: [
                /* @__PURE__ */ e("span", { className: w.outOfStockIndicator }),
                /* @__PURE__ */ e("span", { children: _("PDP_Out_Of_Stock") })
              ] }),
              v === "discontinued" && /* @__PURE__ */ p("div", { className: w.discontinued, children: [
                /* @__PURE__ */ e("span", { className: w.discontinuedIndicator }),
                /* @__PURE__ */ e("span", { children: _("PDP_Discontinued_Message") })
              ] }),
              v !== "discontinued" && /* @__PURE__ */ e(
                m.AddToCart,
                {
                  ...n ?? { template: "quantity-picker" }
                }
              ),
              /* @__PURE__ */ e(
                cn,
                {
                  ...h,
                  className: w.shippingBarometer
                }
              )
            ] }),
            /* @__PURE__ */ p("div", { className: w.detailsWrapper, children: [
              /* @__PURE__ */ e(m.Details.ShortDescription, {}),
              /* @__PURE__ */ e(m.Details.Description, { ...s }),
              /* @__PURE__ */ e(
                m.Specifications,
                {
                  ...i ?? { template: "table" }
                }
              )
            ] }),
            /* @__PURE__ */ p("div", { className: w.attributesWrapper, children: [
              /* @__PURE__ */ e(
                m.Attributes,
                {
                  template: "progress-bar",
                  ...c
                }
              ),
              r && /* @__PURE__ */ e("div", { className: w.tags, children: r.map((S, f) => /* @__PURE__ */ e(m.Attributes, { ...S }, f)) })
            ] }),
            /* @__PURE__ */ e("div", { className: w.relatedProductsWrapper, children: /* @__PURE__ */ e(
              m.RelatedProducts,
              {
                template: "swiper",
                swiperSettings: {
                  settings: {
                    template: "template1",
                    ...(b = l == null ? void 0 : l.swiperSettings) == null ? void 0 : b.settings,
                    headerSettings: {
                      heading: {
                        heading: _("PDP_Related_Products_Header")
                      }
                    }
                  }
                }
              }
            ) })
          ]
        }
      );
    }
  )
), Vt = t.object({
  template: t.literal("malibu"),
  variants: t.custom().optional(),
  productTypeSettings: pe.optional(),
  relatedProductsSettings: ie.optional(),
  siblingSettings: Xe.optional(),
  sizePickerSettings: Se.optional(),
  uspBlockSettings: me.optional(),
  giftWithPurchaseSettings: Ot.optional(),
  extendAccordion: t.array(Ue).optional(),
  sizeGuideSettings: ze.optional(),
  sizeGuideTriggerSettings: xe.optional(),
  priceSettings: bt.optional(),
  priceCalloutSlot: t.custom().optional(),
  belowTheFoldComponents: t.custom().optional(),
  reviewComponentSlot: t.custom().optional(),
  sizeFinderSlot: t.custom().optional(),
  sizeFinderSlotPosition: t.enum(["above-atc", "below-atc"]).optional(),
  openFirstAccordionItem: t.boolean().optional(),
  alwaysShowStickyAddToCart: t.boolean().optional(),
  tagsComponentSlot: t.custom().optional(),
  bundleUpsell: t.custom().optional(),
  aiSummarySlot: t.custom().optional(),
  accordionRootSettings: t.custom().optional(),
  bundleDisplayStyle: t.enum(["card", "text"]).optional(),
  enableImageGalleryZoom: t.boolean().optional()
}), is = y(
  "ProductTemplateAsMalibu",
  P(
    {
      schema: Vt,
      defaultProps: {
        template: "malibu",
        relatedProductsSettings: {
          template: "swiper",
          swiperSettings: {
            settings: {
              template: "template1",
              spacing: {
                y: {
                  initial: "lg",
                  lg: "md",
                  xl: "md"
                }
              },
              itemsInView: {
                initial: "2.1",
                lg: "4.2",
                xl: "5"
              },
              variants: {
                layout: "stacked",
                background: { initial: "none", lg: "white" }
              }
            }
          }
        }
      }
    },
    ({
      relatedProductsSettings: a,
      productTypeSettings: o,
      siblingSettings: n,
      sizePickerSettings: s,
      uspBlockSettings: i,
      extendAccordion: c,
      sizeGuideSettings: r,
      sizeGuideTriggerSettings: l,
      giftWithPurchaseSettings: u,
      priceSettings: h,
      priceCalloutSlot: g,
      belowTheFoldComponents: v,
      reviewComponentSlot: _,
      accordionRootSettings: w,
      sizeFinderSlot: b,
      bundleUpsell: S,
      sizeFinderSlotPosition: f,
      tagsComponentSlot: D,
      openFirstAccordionItem: C,
      alwaysShowStickyAddToCart: x,
      aiSummarySlot: A,
      bundleDisplayStyle: G,
      enableImageGalleryZoom: U
    }) => {
      var Y;
      const d = O(), z = Ca.styles(), R = L(), E = K("fit_text", t.string()), [M, F] = V(
        void 0
      );
      return $(() => {
        const N = () => F("reviews");
        return window.addEventListener("pdp:open-reviews", N), () => window.removeEventListener("pdp:open-reviews", N);
      }, []), /* @__PURE__ */ p("section", { className: z.base, children: [
        /* @__PURE__ */ e(dt, { template: "drawer" }),
        /* @__PURE__ */ e(
          m.ImageGallery,
          {
            template: "keen",
            indicator: "dots",
            zoom: U
          }
        ),
        /* @__PURE__ */ e(
          m.StickyAddToCart,
          {
            template: "button",
            mode: x ? "isNotVisible" : "isScrolledPast"
          }
        ),
        /* @__PURE__ */ e(m.ImageGallery, { template: "grid", zoom: U }),
        /* @__PURE__ */ p("section", { className: z.detailsWrapper, children: [
          /* @__PURE__ */ e(
            se,
            {
              enableWrapper: !1,
              variants: { isOn: "pdp" },
              layout: {
                spacing: { applySpacing: "false" },
                position: { applyPosition: "false" }
              }
            }
          ),
          /* @__PURE__ */ e(m.Details.Name, {}),
          /* @__PURE__ */ e(
            m.Details.Price,
            {
              ...h,
              priceHistoryDrawerSettings: {
                isEnabled: !0,
                trigger: /* @__PURE__ */ e(dn, { className: "w-3 h-3 lg:w-4 lg:h-4 fill-[#71717a]" })
              }
            }
          ),
          /* @__PURE__ */ e(m.Details.ProductType, { ...o }),
          g,
          _,
          D,
          /* @__PURE__ */ e(m.Siblings, { template: "image-card", ...n }),
          /* @__PURE__ */ e(
            m.SizePicker,
            {
              template: "button-grid",
              ...s
            }
          ),
          /* @__PURE__ */ e(m.BundlePromoBanner, {}),
          /* @__PURE__ */ e(m.Bundle, {}),
          f !== "below-atc" && b && b,
          /* @__PURE__ */ e(
            m.AddToCart,
            {
              template: "button",
              isNotifyMeEnabled: (Y = s == null ? void 0 : s.notifyMe) == null ? void 0 : Y.enabled
            }
          ),
          f === "below-atc" && b && b,
          G === "text" && /* @__PURE__ */ e(m.BundleUpsell, {}),
          (E == null ? void 0 : E.value) && /* @__PURE__ */ e("span", { className: z.fitText, children: E.value }),
          /* @__PURE__ */ e(m.SizeRecommendation, { template: "scale" }),
          (r == null ? void 0 : r.enabled) && /* @__PURE__ */ e(
            m.SizeGuideTrigger,
            {
              ...l,
              label: R("Size_Guide_Trigger_Label")
            }
          ),
          /* @__PURE__ */ e(m.SizeGuide, { template: "drawer", ...r }),
          /* @__PURE__ */ e(m.UspBlock, { ...i }),
          G === "card" && S,
          A,
          /* @__PURE__ */ e(m.GiftWithPurchase, { ...u }),
          /* @__PURE__ */ e(
            m.Attributes,
            {
              template: "icon-blocks",
              attributeKey: "productFeaturesVariant"
            }
          ),
          /* @__PURE__ */ e(
            m.Details.Accordion,
            {
              items: [
                {
                  content: {
                    trigger: R("PDP_Product_Description"),
                    value: "description",
                    forceMount: !0,
                    content: d.content.description
                  }
                },
                {
                  content: {
                    trigger: R("PDP_Fabric_Care"),
                    attributeKey: "fabricCare_text",
                    forceMount: !0
                  }
                },
                {
                  content: {
                    trigger: R("PDP_Product_Details"),
                    forceMount: !0,
                    content: d.content.shortDescription
                  }
                },
                ...c ?? []
              ],
              settings: {
                radixAccordionSettings: {
                  root: w ?? {
                    type: "single",
                    value: M,
                    defaultValue: C ? "description" : void 0,
                    onValueChange: (N) => F(N)
                  }
                }
              }
            }
          )
        ] }),
        v
      ] });
    }
  )
), Ut = t.object({
  template: t.literal("vienna"),
  variants: t.custom().optional(),
  relatedProductsSettings: ie.optional(),
  sizePickerSettings: ve.optional(),
  sizePicker2Settings: ve.optional(),
  uspBlockSettings: me.optional(),
  imageGallerySettings: Le.optional(),
  siblingsPickerSettings: we.optional(),
  reviewCarouselComponent: t.custom().optional(),
  reviewStarsComponent: t.custom().optional(),
  detailsComponentSlot: t.custom().optional(),
  sizeGuideComponentSlot: t.custom().optional(),
  beforeSiblingsSlot: t.custom().optional(),
  afterSiblingsSlot: t.custom().optional(),
  belowTheFoldComponents: t.custom().optional(),
  afterAddToCartSlot: t.custom().optional(),
  afterAttributesSlot: t.custom().optional(),
  washingInstructionDrawer: t.custom().optional()
}), rs = () => /* @__PURE__ */ e(m.AddToCart, { template: "button" }), ls = ({
  sizePickerSettings: a,
  sizePicker2Settings: o
}) => {
  const n = L(), s = Ra();
  return /* @__PURE__ */ e(Q, { children: s ? /* @__PURE__ */ p(Q, { children: [
    /* @__PURE__ */ e(m.SizePicker, { ...a, template: "modal" }),
    /* @__PURE__ */ e(
      m.SizePicker,
      {
        ...o,
        template: "modal",
        triggerLabel: n("PDP_Add_To_Cart"),
        customOverlayId: "size-picker-modal-2"
      }
    )
  ] }) : /* @__PURE__ */ e(
    fe,
    {
      label: n("PDP_Out_Of_Stock"),
      disabled: !0,
      "aria-disabled": "true",
      variants: {
        width: "full"
      }
    }
  ) });
}, cs = y(
  "ProductTemplateAsVienna",
  P(
    {
      schema: Ut,
      defaultProps: {
        template: "vienna",
        sizePickerSettings: {
          template: "modal",
          buttonVariants: {
            color: "black",
            style: "outline",
            width: "full"
          }
        },
        sizePicker2Settings: {
          template: "modal",
          buttonVariants: {
            style: "solid",
            width: "full"
          }
        },
        relatedProductsSettings: {
          template: "image-cards"
        }
      }
    },
    ({
      relatedProductsSettings: a,
      sizePickerSettings: o,
      sizePicker2Settings: n,
      uspBlockSettings: s,
      imageGallerySettings: i,
      siblingsPickerSettings: c,
      detailsComponentSlot: r,
      reviewStarsComponent: l,
      sizeGuideComponentSlot: u,
      beforeSiblingsSlot: h,
      afterSiblingsSlot: g,
      belowTheFoldComponents: v,
      washingInstructionDrawer: _,
      afterAddToCartSlot: w,
      afterAttributesSlot: b
    }) => {
      var z, R, E, M, F, Y;
      const S = O(), f = Aa.styles(), D = L(), C = Z(), x = (z = K(
        "product_highlight_text",
        t.string()
      )) == null ? void 0 : z.value, A = (R = K(
        "pr_video_url",
        t.string()
      )) == null ? void 0 : R.value, G = (E = K("pr_badge", t.string().array())) == null ? void 0 : E.value, U = (M = K(
        "washing_advice_text",
        t.string()
      )) == null ? void 0 : M.value, d = C === "simple";
      return /* @__PURE__ */ p("section", { className: f.base, children: [
        /* @__PURE__ */ e("div", { className: f.breadcrumbsWrapper, children: /* @__PURE__ */ e(
          se,
          {
            layout: {
              spacing: { applySpacing: "false" },
              position: { applyPosition: "false" }
            }
          }
        ) }),
        /* @__PURE__ */ e(
          m.ImageGallery,
          {
            template: "keen",
            indicator: "dots",
            buttonInSlider: {
              enabled: !!(A && (A == null ? void 0 : A.length) > 0),
              onClick: () => {
                const N = document == null ? void 0 : document.getElementById("youtube-video");
                N && N.scrollIntoView({ behavior: "smooth" });
              },
              label: D("Product_Video_Button_Text")
            },
            ...i,
            children: /* @__PURE__ */ e("div", { className: f.badgesWrapper, children: G == null ? void 0 : G.map((N, I) => /* @__PURE__ */ e(Ke, { label: N }, I)) })
          }
        ),
        /* @__PURE__ */ p("section", { className: f.detailsWrapper, children: [
          /* @__PURE__ */ p("div", { className: "flex flex-row justify-between items-center lg:mt-0 mb-2", children: [
            /* @__PURE__ */ p("div", { className: "flex items-center empty:hidden flex-wrap", children: [
              /* @__PURE__ */ e(m.Details.ProductType, { attributeKey: "wiring" }),
              ((F = K("wiring", t.string())) == null ? void 0 : F.value) && ((Y = K("padding", t.string())) == null ? void 0 : Y.value) && /* @__PURE__ */ e("span", { className: "m-1 mb-2", children: "•" }),
              /* @__PURE__ */ e(m.Details.ProductType, { attributeKey: "padding" })
            ] }),
            l
          ] }),
          /* @__PURE__ */ e(m.Details.Name, {}),
          /* @__PURE__ */ e(m.Details.Price, {}),
          h,
          /* @__PURE__ */ e(
            m.Siblings,
            {
              template: "color-swatch",
              ...c
            }
          ),
          g,
          /* @__PURE__ */ p("div", { className: "flex flex-col gap-2", children: [
            u,
            /* @__PURE__ */ e(
              "div",
              {
                className: "w-full flex flex-row gap-4",
                id: "add-to-cart-component",
                children: d ? /* @__PURE__ */ e(rs, {}) : /* @__PURE__ */ e(
                  ls,
                  {
                    sizePicker2Settings: n,
                    sizePickerSettings: o
                  }
                )
              }
            ),
            w
          ] }),
          /* @__PURE__ */ e(m.UspBlock, { ...s }),
          /* @__PURE__ */ e(
            m.StickyAddToCart,
            {
              template: "button",
              mode: "isNotVisible",
              selectSizeAction: "open-size-picker",
              withSizePicker: !0
            }
          )
        ] }),
        /* @__PURE__ */ e(m.Details.Description, {}),
        x && /* @__PURE__ */ e("ul", { className: f.highlightTextWrapper, children: x == null ? void 0 : x.split(";").map((N, I) => /* @__PURE__ */ e("li", { className: f.highlightTextRow, children: N }, I)) }),
        /* @__PURE__ */ p("section", { className: f.attributesWrapper, children: [
          /* @__PURE__ */ e(
            m.Attributes,
            {
              template: "row",
              attributeKey: "material_pdp_text"
            }
          ),
          /* @__PURE__ */ e(
            m.Attributes,
            {
              template: "row",
              data: {
                attributeLabel: D("washing_advice_text"),
                value: /* @__PURE__ */ p(Q, { children: [
                  U,
                  " ",
                  _
                ] })
              }
            }
          ),
          /* @__PURE__ */ e(
            m.Attributes,
            {
              template: "row",
              attributeKey: "product_key",
              data: {
                attributeLabel: D("Article_Number"),
                value: S.productKey
              }
            }
          ),
          /* @__PURE__ */ e(
            m.Attributes,
            {
              template: "row",
              attributeKey: "hooks_and_eye_text"
            }
          )
        ] }),
        b,
        A && /* @__PURE__ */ e("div", { className: f.productVideo, id: "youtube-video", children: /* @__PURE__ */ e(
          "div",
          {
            className: "relative w-full",
            style: { paddingBottom: "56.25%" },
            children: /* @__PURE__ */ e(
              "iframe",
              {
                className: "absolute top-0 left-0 w-full h-full",
                src: A.includes("youtube.com/watch?v=") ? `https://www.youtube.com/embed/${A.split("v=")[1]}` : A,
                title: "Product video",
                frameBorder: "0",
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                allowFullScreen: !0
              }
            )
          }
        ) }),
        /* @__PURE__ */ e(
          m.RelatedProducts,
          {
            template: "image-cards",
            relationType: "standard",
            ...a
          }
        ),
        r,
        v
      ] });
    }
  )
), $t = t.object({
  template: t.literal("graz"),
  variants: t.custom().optional(),
  productTypeSettings: pe.optional(),
  productDesignerSettings: pe.extend({
    link: t.string().optional()
  }).optional(),
  relatedProductsSettings: ie.optional(),
  sizePickerSettings: Se.optional(),
  uspBlockSettings: me.optional(),
  siblingsPickerSettings: we.optional(),
  sizeGuideSettings: ze.optional(),
  sizeGuideTriggerSettings: xe.optional(),
  productSku: t.string().optional(),
  ecomidNudgeSlot: t.custom().optional(),
  belowTheFoldComponents: t.custom().optional(),
  reviewComponentSlot: t.custom().optional(),
  extendAccordion: t.array(Ue).optional(),
  accordionRootSettings: t.custom().optional()
}), ds = y(
  "ProductTemplateAsGraz",
  P(
    {
      schema: $t,
      defaultProps: {
        template: "graz",
        relatedProductsSettings: {
          template: "swiper",
          swiperSettings: {
            settings: {
              template: "template1",
              itemsInView: {
                initial: "2.1",
                lg: "4",
                xl: "4"
              },
              spacing: {
                y: {
                  initial: "lg",
                  lg: "md",
                  xl: "md"
                }
              },
              variants: {
                background: { initial: "none", lg: "white" }
              }
            }
          }
        }
      }
    },
    ({
      relatedProductsSettings: a,
      productTypeSettings: o,
      productDesignerSettings: n,
      sizePickerSettings: s,
      uspBlockSettings: i,
      siblingsPickerSettings: c,
      sizeGuideSettings: r,
      sizeGuideTriggerSettings: l,
      ecomidNudgeSlot: u,
      belowTheFoldComponents: h,
      productSku: g,
      reviewComponentSlot: v,
      extendAccordion: _,
      accordionRootSettings: w
    }) => {
      var G, U, d;
      const b = O(), S = Ba.styles(), f = L(), D = K("manufacturer", t.string()), C = un(), [x, A] = V(
        void 0
      );
      return $(() => {
        const z = () => {
          A("reviews"), setTimeout(() => {
            const R = document.getElementById("testfreaks-reviews"), E = R == null ? void 0 : R.closest('[role="region"]'), M = (E == null ? void 0 : E.parentElement) ?? R;
            M == null || M.scrollIntoView({ behavior: "smooth", block: "start" });
          }, 50);
        };
        return window.addEventListener("pdp:open-reviews", z), () => window.removeEventListener("pdp:open-reviews", z);
      }, []), /* @__PURE__ */ e(de, { mode: "wait", children: /* @__PURE__ */ p(
        J.section,
        {
          initial: { opacity: 0 },
          animate: { opacity: 1 },
          exit: { opacity: 0 },
          id: b.productId,
          className: S.base,
          children: [
            /* @__PURE__ */ e(dt, { template: "drawer" }),
            /* @__PURE__ */ e(
              se,
              {
                variants: { isOn: "pdp" },
                enableWrapper: !1,
                className: "block lg:hidden"
              }
            ),
            /* @__PURE__ */ e(m.ImageGallery, { template: "keen", indicator: "dots" }),
            /* @__PURE__ */ e(m.StickyAddToCart, { template: "button", mode: "isNotVisible" }),
            /* @__PURE__ */ e(m.ImageGallery, { template: "grid" }),
            /* @__PURE__ */ p("section", { className: S.detailsWrapper, children: [
              /* @__PURE__ */ e(
                se,
                {
                  variants: { isOn: "pdp" },
                  enableWrapper: !1,
                  className: "hidden lg:block"
                }
              ),
              /* @__PURE__ */ p("div", { className: S.tagsWrapper, children: [
                /* @__PURE__ */ e(m.Details.ProductType, { ...o }),
                /* @__PURE__ */ e(C, { href: (n == null ? void 0 : n.link) ?? "", children: /* @__PURE__ */ e(m.Details.ProductType, { ...n }) })
              ] }),
              /* @__PURE__ */ e(m.Details.Name, {}),
              /* @__PURE__ */ e(m.Details.Price, {}),
              /* @__PURE__ */ e(m.Attributes, { template: "tags", attributeKey: "sticker" }),
              v ? /* @__PURE__ */ e("div", { className: "col-span-full lg:col-start-3 lg:col-end-4 lg:row-start-3 lg:justify-self-end empty:hidden", children: v }) : null,
              /* @__PURE__ */ e(
                m.Siblings,
                {
                  template: "image-card",
                  ...c
                }
              ),
              /* @__PURE__ */ e(m.SizeGuide, { template: "drawer", ...r }),
              /* @__PURE__ */ e(
                m.SizePicker,
                {
                  template: "button-grid",
                  ...s,
                  headerContent: /* @__PURE__ */ e(
                    m.SizeGuideTrigger,
                    {
                      ...l,
                      label: f("Size_Guide_Trigger_Label")
                    }
                  )
                }
              ),
              /* @__PURE__ */ e(
                m.AddToCart,
                {
                  template: "button",
                  isNotifyMeEnabled: (G = s == null ? void 0 : s.notifyMe) == null ? void 0 : G.enabled
                }
              ),
              /* @__PURE__ */ e(m.UspBlock, { ...i }),
              /* @__PURE__ */ e(
                m.Attributes,
                {
                  label: f("PDP_Product_Features_Label"),
                  template: "icon-blocks",
                  attributeKey: "productFeatures"
                }
              ),
              /* @__PURE__ */ e(
                m.Details.Accordion,
                {
                  settings: {
                    radixAccordionSettings: {
                      root: w ?? {
                        type: "single",
                        collapsible: !0,
                        value: x,
                        onValueChange: (z) => A(z)
                      }
                    }
                  },
                  items: [
                    {
                      content: {
                        forceMount: !0,
                        trigger: f("PDP_Product_Details"),
                        content: b.content.description
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: f("PDP_Fabric_Care"),
                        attributeKey: "fabricCare_text"
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: f("PDP_Product_Material"),
                        attributeKey: "pr_fabric"
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: f("PDP_Product_CareGuide"),
                        attributeKey: "care_guide"
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: f("PDP_Product_Manufacturer"),
                        content: /* @__PURE__ */ p("div", { className: "flex flex-col gap-3", children: [
                          /* @__PURE__ */ e("retraced-icons", {}),
                          D == null ? void 0 : D.value
                        ] })
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: f("PDP_Product_Shipping"),
                        attributeKey: "shipping"
                      }
                    },
                    ..._ ?? []
                  ]
                }
              ),
              /* @__PURE__ */ e(
                m.Attributes,
                {
                  label: f("PDP_Product_Certifications"),
                  template: "icon-blocks",
                  attributeKey: "certifications"
                }
              ),
              u,
              /* @__PURE__ */ e("span", { className: S.productId, children: f("PDP_Product_Id", {
                productId: b.productId,
                sku: g || ""
              }) })
            ] }),
            /* @__PURE__ */ e("div", { className: S.relatedProductsWrapper, children: /* @__PURE__ */ e(
              m.RelatedProducts,
              {
                template: "swiper",
                swiperSettings: {
                  settings: {
                    template: "template1",
                    ...(U = a == null ? void 0 : a.swiperSettings) == null ? void 0 : U.settings,
                    headerSettings: {
                      heading: {
                        heading: f("PDP_Related_Products_Header")
                      }
                    }
                  }
                }
              }
            ) }),
            h,
            /* @__PURE__ */ e("div", { className: S.relatedProductsWrapper, children: /* @__PURE__ */ e(
              m.RelatedProducts,
              {
                template: "swiper",
                swiperSettings: {
                  settings: {
                    template: "template1",
                    ...(d = a == null ? void 0 : a.swiperSettings) == null ? void 0 : d.settings,
                    headerSettings: {
                      heading: {
                        heading: f("PDP_Related_Products_Header")
                      }
                    }
                  }
                }
              }
            ) })
          ]
        }
      ) });
    }
  )
), Ft = t.object({
  template: t.literal("salzburg"),
  variants: t.custom().optional(),
  relatedProductsSettings: ie.optional(),
  sizePickerSettings: ve.optional(),
  uspBlockSettings: me.optional(),
  siblingsPickerSettings: we.optional(),
  imageGallerySettings: Le.optional(),
  descriptionSettings: Ve.optional(),
  nameSettings: mt.optional(),
  customSiblings: t.custom().optional()
}), us = y(
  "ProductTemplateAsSalzburg",
  P(
    {
      schema: Ft,
      defaultProps: {
        template: "salzburg",
        relatedProductsSettings: {
          template: "image-cards"
        }
      }
    },
    ({
      sizePickerSettings: a,
      imageGallerySettings: o,
      nameSettings: n,
      descriptionSettings: s,
      siblingsPickerSettings: i,
      variants: c,
      customSiblings: r
    }) => {
      const l = ge.main.styles(c), u = L();
      return /* @__PURE__ */ p("section", { className: l.base, children: [
        /* @__PURE__ */ p("section", { className: l.detailsWrapper, children: [
          /* @__PURE__ */ e(
            m.Details.Name,
            {
              ...n,
              blueprint: ge.details
            }
          ),
          /* @__PURE__ */ e(
            m.Details.Description,
            {
              ...s,
              blueprint: ge.details
            }
          ),
          r || /* @__PURE__ */ e(
            m.Siblings,
            {
              template: "color-swatch",
              ...i
            }
          ),
          /* @__PURE__ */ p("div", { className: "w-full flex flex-col lg:flex-row gap-3 lg:gap-4 justify-between", children: [
            /* @__PURE__ */ e(
              m.Details.Price,
              {
                blueprint: ge.details
              }
            ),
            /* @__PURE__ */ e(
              m.SizePicker,
              {
                template: "modal",
                ...a,
                triggerLabel: "PDP_Add_To_Cart"
              }
            )
          ] }),
          /* @__PURE__ */ e("span", { className: l.returnPolicyWrapper, children: u("Product_Return_Policy") })
        ] }),
        /* @__PURE__ */ e(
          m.ImageGallery,
          {
            template: "keen",
            indicator: "dots",
            blueprint: ge.gallery,
            ...o
          }
        )
      ] });
    }
  )
), Yt = t.object({
  template: t.literal("linz"),
  variants: t.custom().optional()
}), ps = y(
  "ProductTemplateAsLinz",
  P(Yt, () => /* @__PURE__ */ p(m.Root, { template: "grid", children: [
    /* @__PURE__ */ e(
      m.ImageGallery,
      {
        template: "keen",
        indicator: "number",
        slidesPerView: { mobile: 1, tablet: 1, desktop: 3 },
        gap: { mobile: 0, tablet: 0, desktop: 0 }
      }
    ),
    /* @__PURE__ */ p("div", { className: "col-span-12 lg:col-start-9 lg:col-end-13 top-0 left-0 row-start-1 row-end-2 flex flex-col p-4 bg-[#aeaeae7d] backdrop-blur-lg rounded-lg sticky right-6 place-self-end w-full order-2 h-fit lg:self-end lg:p-6", children: [
      /* @__PURE__ */ e(m.Details.Name, {}),
      /* @__PURE__ */ e(m.Details.Price, {}),
      /* @__PURE__ */ e(m.Siblings, { template: "image-card" }),
      /* @__PURE__ */ e(m.SizePicker, { template: "button-grid" }),
      /* @__PURE__ */ e(m.AddToCart, { template: "button" })
    ] })
  ] }))
), ms = t.discriminatedUnion("template", [
  Ht,
  Kt,
  Vt,
  Ut,
  $t,
  Ft,
  Yt
]), Js = y(
  "ProductTemplate",
  P(ms, (a) => a.template === "basic" ? /* @__PURE__ */ e(os, { ...a }) : a.template === "helsinki" ? /* @__PURE__ */ e(ss, { ...a }) : a.template === "malibu" ? /* @__PURE__ */ e(is, { ...a }) : a.template === "vienna" ? /* @__PURE__ */ e(cs, { ...a }) : a.template === "graz" ? /* @__PURE__ */ e(ds, { ...a }) : a.template === "salzburg" ? /* @__PURE__ */ e(us, { ...a }) : a.template === "linz" ? /* @__PURE__ */ e(ps, { ...a }) : null)
), ei = (a) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...a,
    children: /* @__PURE__ */ e(
      "path",
      {
        stroke: "#18181B",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m13.5999 4-7.7 7.7-3.5-3.5"
      }
    )
  }
);
export {
  Ln as Accordion,
  mo as AddToCart,
  po as AddToCartButton,
  lo as AddToCartQuanityPickerRow,
  co as AddToCartQuantityPicker,
  oo as Attributes,
  eo as AttributesAsIconBlocks,
  qn as AttributesAsProgressBar,
  ao as AttributesAsRow,
  Jn as AttributesAsTags,
  no as AttributesPropsSchema,
  qs as AttributesTagsItemSchema,
  os as Basic,
  _n as Brand,
  wn as BrandSchema,
  Ro as Bundle,
  ns as BundlePromoBanner,
  gt as BundleSavingsBadge,
  Fo as BundleUpsell,
  ei as Checkmark,
  pn as CrossSvg,
  Sn as Description,
  zn as Details,
  vt as FULL_VIEWPORT_DISPLAY_SIZE,
  Yo as GiftWithPurchase,
  ds as Graz,
  ss as Helsinki,
  so as IconMinus,
  io as IconPlus,
  Yn as ImageGallery,
  $n as ImageGalleryAsGrid,
  Vn as ImageGalleryAsKeen,
  ps as Linz,
  is as Malibu,
  vn as Name,
  Tn as Price,
  Nn as PriceHistoryDrawer,
  bt as PriceSchema,
  m as Product,
  Js as ProductTemplate,
  ms as ProductTemplatePropsSchema,
  Dn as ProductType,
  Do as RelatedProducts,
  Rt as RelatedProductsImageCards,
  Bo as RelatedProductsSwiper,
  fn as Root,
  hn as RootAsDrawer,
  mn as RootAsDrawerDialog,
  ut as RootAsDrawerSchema,
  bn as RootAsGrid,
  pt as RootAsGridSchema,
  gn as RootPropsSchema,
  $e as SHOP_THE_LOOK_ATTRIBUTE_KEY,
  Bt as STATUS_TRANSLATIONS,
  us as Salzburg,
  ft as ShopTheLook,
  Gn as ShopTheLookItem,
  Pn as ShortDescription,
  yn as ShortDescriptionSchema,
  To as SiblingColorSwatchList,
  Co as Siblings,
  So as SiblingsImageCard,
  Jo as SizeGuide,
  Xo as SizeGuideContent,
  qo as SizeGuideDrawer,
  es as SizeGuideTrigger,
  Po as SizePicker,
  ho as SizePickerButtonGrid,
  vo as SizePickerModal,
  Uo as SizeRecommendation,
  Ko as SizeRecommendationScale,
  Qn as Specifications,
  Xn as SpecificationsAsTable,
  _t as SpecificationsAsTableSchema,
  xo as StickyAddToCart,
  Lo as StickyAddToCartButton,
  Lt as Swatch,
  Ho as UspBlock,
  cs as Vienna,
  Bn as Wrapper,
  An as WrapperSchema,
  Pt as ZoomCursorOverlay,
  Ue as accordionItemSchema,
  In as accordionSchema,
  Dt as addToCartButtonSchema,
  At as addToCartQuantityPickerSchema,
  It as addToCartSchema,
  Nt as attributesAsIconBlocksSchema,
  Fe as attributesAsProgressBarSchema,
  Tt as attributesAsRowSchema,
  Ye as attributesAsTagsSchema,
  Zn as attributesProgressBarItemSchema,
  xn as bundleSavingsBadgeSchema,
  Ve as descriptionSchema,
  Ot as giftWithPurchaseSchema,
  St as imageGalleryAsGridSchema,
  Le as imageGalleryAsKeenSchema,
  wt as imageGalleryPropsSchema,
  mt as nameSchema,
  ht as priceHistoryDrawerSchema,
  Wt as productSizeRecommendationScaleSchema,
  Ht as productTemplateAsBasicSchema,
  $t as productTemplateAsGrazSchema,
  Kt as productTemplateAsHelsinkiSchema,
  Yt as productTemplateAsLinzSchema,
  Vt as productTemplateAsMalibuSchema,
  Ft as productTemplateAsSalzburgSchema,
  Ut as productTemplateAsViennaSchema,
  pe as productTypeSchema,
  xt as relatedProductsImageCardsSchema,
  ie as relatedProductsSchema,
  Et as relatedProductsSwiperSchema,
  En as shopTheLookItemSchema,
  Wn as shopTheLookSchema,
  zt as siblingColorSwatchListSchema,
  Xe as siblingsImageCardSchema,
  we as siblingsSchema,
  jt as sizeGuideContentSchema,
  Mt as sizeGuideDrawerSchema,
  ze as sizeGuideSchema,
  xe as sizeGuideTriggerSchema,
  Se as sizePickerButtonGridSchema,
  ve as sizePickerModalSchema,
  yo as sizePickerSchema,
  Vo as sizeRecommendationSchema,
  kt as specificationsPropsSchema,
  Gt as stickyAddToCartButtonSchema,
  zo as stickyaddToCartSchema,
  uo as useAddToCartLabel,
  Io as useElementVisibility,
  yt as useImageZoom,
  me as uspBlockSchema
};
//# sourceMappingURL=index.es.js.map
